import { ServiceLayer } from '../../services/serviceLayer';
import { DAO } from './../../../app/modal/DAO';
import { FormGroup, FormBuilder, FormControl,  FormGroupDirective } from '@angular/forms';
import { NgForm } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';
import { ConfirmationService, MessageService } from 'primeng/api';
// import * as $ from 'jquery';
import { of } from 'rxjs';
import { Settings } from '../../services/settings';
import { Component, Inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { Renderer2 } from '@angular/core';

declare var $: any;
// var $: any;

declare var require: any
let jsonPathRef = require('jsonpath');

@Component({
  selector: 'app-policyquotes',
  templateUrl: './policyquotes.component.html',
  providers: [MessageService]
})
export class PolicyquotesComponent implements OnInit {
  @ViewChild('addresstext') addresstext: any;
  @ViewChild ('policy') policyDetailForm :any;
  @ViewChild('financialIntform') financialIntform: FormGroupDirective;
  public showPolicyConfirm:boolean = false;
  public MailEdit={
    "showstreetNo":true,
    "showaddress1":true,
    "showcity":true,
    "showcounty":true,
    "showstate":true,
    "showpostalCode":true
  };
  public BillingEdit={
    "showstreetNo":true,
    "showaddress1":true,
    "showcity":true,
    "showcounty":true,
    "showstate":true,
    "showpostalCode":true
  };
  public lastActive:any;
  public ActiveIndex:any;
  public dropdownResult:any;
  public originalProjectLimit:any;
  public updateBlanketQuestionnaire:any;
  public updateNamedInsuredQuestionnaire:any;
  public MailingQuestionnaire:any;
  public ProjectQuestionaire:any;
  public BillingQuestionnaire:any;
  public MailingForm:any={};
  public tempMailingForm:any={};
  public BillingAddressInfo:any={};
  public tempBillingAddressInfo:any={};
  public showExpiration : boolean = true;
  public showInterestType : boolean = true;  
  public IsPolicyExtensionAllowed : boolean = true; 
  public showBusinessName : boolean = true;  
  public showInterestAddress : boolean = true;  
  public NameQuestionnaire:any;
  public NameInsuredId:any;
  public BlanketValue:any;
  public BlanketInfo:any= {
    "showBlanket":false,
    "blanketList":[],
    "blanketAI":null,
    "showBlanketAIEdit":true,
    "tempBlanketValue":null
  };
  public PayPlanInfo:any= {
    "showPayPlan":false,
    "PayPlanList":[],
    "PayPlan":null,
    "PayPlanCode":null,
    "showPayPlanEdit":true,
    "tempPayPlanCode":null
  };
  public jp = require('jsonpath')
  public MailingType: String='NewMailingAddress';
  public checked2: boolean = true;
  public policyNumber: String = '';
  public showPolicyError: boolean = false;
  public PolicyOptions: any = [];
  public PolicyQuotesList: any = [];
  public tempPolicyList: any = [];
  public filteredList = [];
  public PolicyorName: any = "";
  public IsCancelPolicy: boolean = false;
  public currentPolicy: any;
  public showCancelPopup: boolean = false;
  public IsOpen: boolean = false;
  public reasonDropdown: any;
  public IsCancel: boolean = false;
  public EditPolicy: boolean = false;
  public IsPolicyEvent:boolean=false;
  public IsPolicyExtensionEnable:boolean = true;
  public policyChangeModal: any;
  public policyChangeValue: boolean = false;
  public policyRequestLabels: any;
  public currentPolicyDetails: any;
  public DisableNameInsured: boolean = true;
  public cancelPopupDetails: any = [];
  public ExtendTermQuestionnaire: any;
  public FinancialInterestTypeQuestionaire: any;
  public PayPlanQuestionaire: any;
  public policyDetails: any;
  public eventDetails: any;
  public isExtendPolicies: any;
  public countiesDetails: any;
  public currentEvent: any;
  public AdditionalInsuredList: any = [];
  public tempAdditionalInsuredList: any = [];
  public showAddInsured: boolean = true;
  public EditMailing: boolean = false;
  public ViewFinancial: boolean = false;
  public EditFinancial: boolean = false;
  public isCreateFinancialInterest: boolean = true;  
  public HideMailEdit: boolean = true;
  public MailigAddressValue: any;
  public input: any;
  address: Object;
  autocompleteInput: string;
  establishmentAddress: Object;
  formattedAddress: string;
  formattedEstablishmentAddress: string;
  phone: string;
  OnErrorAddress: boolean = false;
  ZipValue: any;
  OverWriteForm: FormGroup;
  submitted = false;
  MailSubmitted = false;
  validateAddress = true;
  public EditProject: boolean = false;
  public eventReason:string;
  public EditBilling: boolean = false;  
  public ProjectAddressInfo: any = {};
  public tempProjectAddressInfo: any = {};
  public BillingAddressValue: any;
  public ShowErrorMsg: boolean = false;
  public ShowEditMailView: boolean = false;
  public tempMailValue:any;
  public SelectedAddress:boolean = false;
  public PolicySubmitted:boolean = false;
  PolicDetailsForm:FormData;
  public onEditPolicy:boolean = false;
  public editEffective:boolean = false;
  public closeEffective:boolean = false;
  public editQuestion:boolean = false;
  EffectiveForm:FormGroup;
  public EffectiveSubmitted:boolean=false;
  public NameInsuredUndo:boolean=false;
  public NameInsuredError:boolean=false;
  public tempNameInsured:any;
  public NameInsuredValue:any;
  public effectiveDate:any;
  public expirationDate:any;
  public tempExpirationDate:any;
  public MaxExpirationDate:Date;
  public projectSubmit:boolean = false;
  public billingSubmit:boolean = false;  
  public ShowNameUndo:boolean=false;
  public stateList:any=[];
  public showPremium:boolean = false;
  public premiumValue:any;
  public amendPremiumValue:any;
  public maxDate:any;
  public year:any;
  public maxyear:any;
  public currentExpirationDate:Date;
  public DeductibleList:any=[];
  public FloodList :any =[];
  public EQList:any=[];
  public validateMinProject:boolean=false;
  public validateMaxProject:boolean=false;
  public ProjectLimitValue:any;
  public projectLimitTotal:any;
  public ProjectLimitLabel:any;
  public showConfirmPopup:boolean=false;
  public tempProjectLimitValue :any;
  public coverageQuestionnaire:any;
  public showProjectEdit:boolean=true;
  public showdeductibleEdit:boolean=true;
  public showFloodEdit:boolean=true;
  public showEQEdit:boolean=true;
  public showDescription:boolean = true;
  public showReason:boolean = true;
  public tempDeductibleNumber:any;
  public tempEQNumber:any;
  public tempFloodNumber:any;
  public deductibleValue:any;
  public floodValue:any;
  public EQValue:any;
  public ReasonList:any;
  public amendReason:any=[];
  public tempamendReason:any;
  public tempamendDescription:any;
  public showUpdate:boolean = true;
  public submitType:any;
  public tempCurrentPolicy:any;
  public templimits:any={};
  public showBar:boolean = false;
  public isClaimFound:boolean = false;
  public isPendingAmendment:boolean = false;
  public isFromManagePolicy:boolean = false;
  public isShowEvidence:boolean = false;  
  public isShowReportClaim:boolean = false;  
  public isConfirmBPMi:boolean = false;    
  public showBPMIConfirmation:boolean = false;    
  public isConfirmBPMiChange:boolean = false;  
  public isAcceptJobsiteLimit:boolean = false;  
  public isBPMiAmend:boolean = false;    
  public financialEditModel:any = {};
  public interestTypeList:any = [];
  public tempfinancialEditModel:any = {};
  public BPMiFields:any;
  public isBPMiFields:any={};
  public canAmendData:any={};
  public IsExceedExtentioPeriod:boolean = false;
  public IsPolicyPeriodExtensionReached:boolean = false;

  public isCancelExpired:boolean = false;  
  public ExtendPolicyPriorEffectiveDate:boolean = true;
  public IsBFMInternal:boolean = false;
  public showExtendBPMi:boolean = false;
  public statusChecks: string[] = ['CANCELED', 'CANCELLED', 'PENDINGCANCELLATION', 'EXPIRED'];
  public IsLoading : boolean = false;
  showPolicyLockPopup = false;
  policyLockMessage = '';

  constructor(public serviceLayer: ServiceLayer, public dao: DAO, public zone: NgZone,public confirmationService:ConfirmationService,

    private formBuilder: FormBuilder,public datepipe:DatePipe,private messageService: MessageService,private settings: Settings, private renderer: Renderer2) {
  }

  async ngOnInit() {
    this.IsLoading = true; 
    try {
    this.IsCancelPolicy = window.localStorage.getItem("policyType") == "Cancel My Policy" ? true : false;
    // this.PolicyQuotesList = (window.localStorage.getItem("policyQuotesList") != "undefined"?JSON.parse(window.localStorage.getItem("policyQuotesList")):null);
    // Commented this code for BFMIT-336: disable the ‘Extend Policy’ option it works the same for all users    
    // var loginDetails = JSON.parse(window.localStorage.getItem("loginUserDetails"));
    // if(loginDetails?.isinternal && (loginDetails?.email).includes("@berkleymarine.com")){
    //   this.IsBFMInternal = loginDetails?.isinternal;
    // }
    var element = document.getElementById("GettingID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    await this.getPolicyQuotesList();
    this.tempPolicyList = this.PolicyQuotesList;
    await this.getReason();
    await this.serviceLayer.getUnderWriterInformation();    
    var currentPolicyDetails = window.localStorage.getItem("currentPolicy");
    if (currentPolicyDetails != undefined && currentPolicyDetails != null && currentPolicyDetails != "") {
      currentPolicyDetails = JSON.parse(currentPolicyDetails);
      this.PolicyorName = currentPolicyDetails['policyNumber'];
      this.filterPolicy();
      this.IsOpen = true;
    }
    this.OverWriteForm = this.formBuilder.group({
      address2:  new FormControl({value: '', disabled: false,}),
      address1: new FormControl({value: '', disabled: false,}),
      city: new FormControl({value: '', disabled: true}),
      state: new FormControl({value: '', disabled: true}),
      zip: new FormControl({value: null, disabled: true}),
    });
    this.EffectiveForm = this.formBuilder.group({
      effectiveDate: [null],
      expirationDate: [null]
    });
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
    this.postUserActivity(this.PolicyQuotesList,'Success',0,"Load Policy List","policies","searchPoliciesGrid",[this.dao.loginUserDetail.email, this.dao.loginUserDetail?.isInternal == false ? this.dao.loginUserDetail?.isInternal : true, (this.dao.loginUserDetail?.agencies == undefined || this.dao.loginUserDetail?.agencies == '') ? null : this.dao.loginUserDetail?.agencies]);
  }catch (error) {
    console.error("Error during init:", error);
  } finally {
    this.IsLoading = false; // hide spinner once all done
  }
}

  invokeEvent(place: Object) {
    this.SelectedAddress = true;
    this.autocompleteInput = _.cloneDeep(place['formatted_address']);
    this.getAddress(place);
  }
  getAddress(place: object) {
    this.address = place['formatted_address'];
    this.phone = this.getPhone(place);
    this.formattedAddress = place['formatted_address'];
    this.zone.run(() => this.formattedAddress = place['formatted_address']);
  }

  getEstablishmentAddress(place: object) {
    this.establishmentAddress = place['formatted_address'];
    this.phone = this.getPhone(place);
    this.formattedEstablishmentAddress = place['formatted_address'];
    this.zone.run(() => {
      this.formattedEstablishmentAddress = place['formatted_address'];
      this.phone = place['formatted_phone_number'];
    });
  }

  getAddrComponent(place, componentTemplate) {
    let result;

    for (let i = 0; i < place.address_components.length; i++) {
      const addressType = place.address_components[i].types[0];
      if (componentTemplate[addressType]) {
        result = place.address_components[i][componentTemplate[addressType]];
        return result;
      }
    }
    return;
  }

  getStreetNumber(place) {
    const COMPONENT_TEMPLATE = { street_number: 'short_name' },
      streetNumber = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return streetNumber;
  }

  getStreet(place) {
    const COMPONENT_TEMPLATE = { route: 'long_name' },
      street = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return street;
  }

  getCity(place) {
    const COMPONENT_TEMPLATE = { locality: 'long_name' },
      city = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return city;
  }

  getState(place) {
    const COMPONENT_TEMPLATE = { administrative_area_level_1: 'short_name' },
      state = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return state;
  }

  getDistrict(place) {
    const COMPONENT_TEMPLATE = { administrative_area_level_2: 'short_name' },
      state = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return state;
  }

  getCountryShort(place) {
    const COMPONENT_TEMPLATE = { country: 'short_name' },
      countryShort = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return countryShort;
  }

  getCountry(place) {
    const COMPONENT_TEMPLATE = { country: 'long_name' },
      country = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return country;
  }

  getPostCode(place) {
    const COMPONENT_TEMPLATE = { postal_code: 'long_name' },
      postCode = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return postCode;
  }

  getPhone(place) {
    const COMPONENT_TEMPLATE = { formatted_phone_number: 'formatted_phone_number' },
      phone = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return phone;
  }

  onAddNameInsured() {
    if (this.AdditionalInsuredList.length < 6) {
      if(this.AdditionalInsuredList.length == 0) {
        this.AdditionalInsuredList.push({ "id":0,"Disabled": false, "answer": "","showUndo":false,"isDeleted":false,"showErrorMsg":false })
      }
      else {
        if(this.AdditionalInsuredList[this.AdditionalInsuredList.length-1].answer != "") {
          this.AdditionalInsuredList.push({ "id":0,"Disabled": false, "answer": "","showUndo":false,"isDeleted":false,"showErrorMsg":false })
        }
        else {
          this.AdditionalInsuredList[this.AdditionalInsuredList.length-1].showErrorMsg = true;
        }
      }
    }
    if (this.AdditionalInsuredList.length >= 6) {
      this.showAddInsured = false;
    }
  }

  DeleteAdditionalInsured(index) {
    this.AdditionalInsuredList[index].showErrorMsg = false;
    if(this.AdditionalInsuredList[index].id != 0) {
      this.AdditionalInsuredList[index].isDeleted = true;
      this.AdditionalInsuredList[index].showUndo = true;
      this.AdditionalInsuredList[index].Disabled = true;
    }
    else {
      this.AdditionalInsuredList.splice(index,1);
    }
    if (this.AdditionalInsuredList.length < 6) {
      this.showAddInsured = true;
    }
  }

  EditAdditionalInsured(index) {
    setTimeout(function() { $('#additionalNameInsuredID'+index).focus() }, 100);
    if(this.AdditionalInsuredList[index].answer != "") {
      this.AdditionalInsuredList[index].showUndo = true;
      this.AdditionalInsuredList[index].Disabled = false;
    }
  }

  UndoNameAdditionalInsured(index) {
    if(this.AdditionalInsuredList[index].previousValue != undefined) {
      this.AdditionalInsuredList[index].answer = this.AdditionalInsuredList[index].previousValue;
    }
    this.AdditionalInsuredList[index].showUndo = false;
    this.AdditionalInsuredList[index].Disabled = true;
    this.AdditionalInsuredList[index].isDeleted = false;
  }

  ValidateAdditionalName(event,index) {
    if(this.AdditionalInsuredList[index].answer != undefined && this.AdditionalInsuredList[index].answer != null && this.AdditionalInsuredList[index].answer != "") {
      this.AdditionalInsuredList[index].showErrorMsg = false;
    }
    else {
      this.AdditionalInsuredList[index].showErrorMsg = true;
    }
  }

  async getReason() {
    let response = await this.serviceLayer.getCancelReasonDetails();
    if(response != undefined && response.popupInputObj != undefined) {
      this.reasonDropdown = this.jp.query(response,"$..[?(@.key == 'cancelReasonCd')]")[0].questionOptions;
        this.cancelPopupDetails = response['originalObj'];
      }      
    }

  NameInsuredEdit() {
    setTimeout(function() { $('#primaryNamedID').focus() }, 100);
    this.ShowNameUndo = true;
    this.DisableNameInsured = false;
  }

  UndoNameInsured() {
    this.ShowNameUndo = false;
    this.DisableNameInsured = true;
    this.NameInsuredValue = this.tempNameInsured;
    this.NameInsuredError= false;
  }

  ValidateNameInsured() {
    if(this.NameInsuredValue!= undefined && this.NameInsuredValue != null && this.NameInsuredValue!="") {
      this.NameInsuredError= false;
    }
    else {
      this.NameInsuredError = true;
    }
  }

  closeNameInsured() {
    this.DisableNameInsured = true;
    this.AdditionalInsuredList = [];
  }

  DisableNameValues() {
    if(this.AdditionalInsuredList.length>0) {
      var result = true;
      this.AdditionalInsuredList.forEach(element => {
        if(element.answer!="") {
          result = false;
        }
        else {
          result = true;
        }
      });
      if(result) {
        return result;
      }
    }
    if(_.isEqual(this.AdditionalInsuredList,this.tempAdditionalInsuredList)){
      if(this.policyDetails?.clientInfo?.insuredName == this.NameInsuredValue) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }

  async EditNameInsured() {
    this.isConfirmBPMiChange = false;
    this.isConfirmBPMi = false;
    var element = document.getElementById("GettingID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    this.updateNamedInsuredQuestionnaire = await this.serviceLayer.getPolicyQuestionnaire("updateNamedInsured");
    this.EditPolicy = true;
    this.ShowNameUndo = false;
    this.AdditionalInsuredList = [];
    this.tempAdditionalInsuredList = [];
    if (this.policyDetails != undefined && this.policyDetails.clientInfo != undefined &&
      this.policyDetails.clientInfo.additionalInsured != undefined) {
        this.tempNameInsured = this.policyDetails?.clientInfo?.insuredName;
        this.NameInsuredValue = this.policyDetails?.clientInfo?.insuredName;
        this.NameInsuredId = this.policyDetails?.clientInfo?.insuredNameId;
      this.policyDetails?.clientInfo?.additionalInsured.forEach((element,index) => {
        this.tempAdditionalInsuredList.push({ "id":element.id,"Disabled": true, "answer": element.name,"showUndo":false,"isDeleted":false,"showErrorMsg":false,"previousValue":element.name})
        this.AdditionalInsuredList.push({ "id":element.id,"Disabled": true, "answer": element.name,"showUndo":false,"isDeleted":false,"showErrorMsg":false,"previousValue":element.name})
      });
      if (this.policyDetails.clientInfo.additionalInsured.length >= 6) {
        this.showAddInsured = false;
      }
    }
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
    this.NameQuestionnaire = this.jp.query(this.updateNamedInsuredQuestionnaire.questionnaire,"$..[?(@.key == 'NamedInsuredInfo')]")[0].questionAnswer[0];
  }

  async UpdateNameInsured() {
    var questionnaire = _.cloneDeep(this.updateNamedInsuredQuestionnaire);
    var InsuredList = [];
    if(this.AdditionalInsuredList.length>0) {
      var sequenceNumber = 1;
      this.AdditionalInsuredList.forEach((element,index) => {
        var obj = _.cloneDeep(this.NameQuestionnaire);
        obj["answer"]="";
        obj["sequence"]= sequenceNumber + 1;
        sequenceNumber +=1;
        obj["isChanged"]= true;
        obj["propertyName"]="AdditionalNamedInsured";
        let defaultData = this.tempAdditionalInsuredList.filter(c=>c.id == element.id);
        if(defaultData && defaultData.length > 0 && (defaultData[0].answer == element.answer || defaultData[0].id == "0") && element?.previousValue != null && element?.previousValue != ''){
          obj["isChanged"]=false;
        }
        var elementKeys = Object.keys(element);
        elementKeys.forEach(key => {
          if(obj[key] != undefined) {
            obj[key] = element[key];
          } 
        });
        obj["isChanged"] = obj["isDeleted"] == true ? true : obj["isChanged"];
        if(obj["id"] ==0 && obj["isDeleted"]) {}
        else {
          InsuredList.push(obj);
        }
      });
    }
    var AmendLabels = {
      "policyId":this.policyDetails?.policyId,
      "amendEffectiveDate":this.datepipe.transform(new Date(), 'yyyy-MM-dd'),
      "amendType":"updateNamedInsured",
      "amendReasonCd":"INSD_NAM"
    }
    var updateAmendQuestionnaire = this.jp.query(questionnaire.questionnaire,"$..[?(@.key == 'AmendQuestionnare')]")[0].questionAnswer;
    if(updateAmendQuestionnaire.length>0) {
      updateAmendQuestionnaire.forEach(element => {
        if(AmendLabels[element.key] != undefined) {
          element.answer = AmendLabels[element.key];
        }
      });
    }
    var primaryNamedInsured = _.cloneDeep(this.NameQuestionnaire);
    primaryNamedInsured["answer"] = this.NameInsuredValue;
    primaryNamedInsured["id"] = this.NameInsuredId;
    primaryNamedInsured["isChanged"] = true;
    primaryNamedInsured["propertyName"]="NamedInsured";
    if(this.NameInsuredValue == this.tempNameInsured){
      primaryNamedInsured["isChanged"] = false;
    }
    InsuredList.push(primaryNamedInsured);
    this.jp.query(questionnaire.questionnaire,"$..[?(@.key == 'NamedInsuredInfo')]")[0].questionAnswer=InsuredList;
    var element = document.getElementById("UpdateID");
    element != undefined ? element.classList.add("calculateLbl") : null;
    if(this.jp.query(questionnaire,"$..[?(@.key == 'amendReasonText')]")?.length > 0){
      this.jp.query(questionnaire,"$..[?(@.key == 'amendReasonText')]")[0].answer = await this.getAmendDesc("NamedInsured",questionnaire);
    }   
    let previousValue = {
      'NameInsured':this.tempNameInsured,
      'AdditionalNameInsured':this.tempAdditionalInsuredList.length != 0 ? this.tempAdditionalInsuredList : null
    }
    let amendResponse:any = await this.serviceLayer.SubmitNameInsured(questionnaire,previousValue,this.policyDetails.referenceNumber,this.policyDetails?.policyNumber,this.isClaimFound,this.isPendingAmendment,this.NameInsuredValue,this.tempCurrentPolicy?.productCode,this.datepipe.transform(this.tempCurrentPolicy?.effectiveDate, 'yyyy-MM-dd'),this.datepipe.transform(this.tempCurrentPolicy?.expireDate, 'yyyy-MM-dd'),this.tempCurrentPolicy?.noOfAmendmentsMade,this.tempCurrentPolicy?.policyMod);
    element != undefined ? element.classList.remove("calculateLbl") : null;
    this.isBPMiAmend = amendResponse?.isBPMiAmendment == true;
    this.showPolicyConfirm = true;
    this.isClosed = false;
  }

  changeNamedQuestionalire(questionnaire){
    let UpdatedQuestionaire = _.cloneDeep(questionnaire);
    let NamedQuestions = this.jp.query(questionnaire.questionnaire,"$..[?(@.key == 'NamedInsuredInfo')]")[0].questionAnswer;
    if(NamedQuestions && NamedQuestions.length > 0){
      NamedQuestions.forEach(name=>{
        name.isChanged = true;
      });
    }
  }

  async cancelPolicy(policyDetails,id) {
    if(id != undefined && id != null)
    {
      this.ActiveIndex = id;
    }
    var element = document.getElementById("card"+this.ActiveIndex);
    var element = document.getElementById("GettingID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    this.policyDetails = await this.serviceLayer.getPolicyDetails(policyDetails.policyNumber,policyDetails.policyMod);
    if(this.lastActive != undefined && this.lastActive != null) {
      var last = document.getElementById(this.lastActive);
      last != undefined ? last.classList.remove("focuscard") : null; 
      element != undefined ? element.classList.add("focuscard") : null;
      this.lastActive = "card"+this.ActiveIndex;
    }
    else {
      element != undefined ? element.classList.add("focuscard") : null;
      this.lastActive = "card"+this.ActiveIndex;
    }
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
    this.currentPolicy = policyDetails;
    this.showCancelPopup = true;
    let userData:any={};
    userData.Email = this.dao?.loginUserDetail?.email;
    userData.AgencyCode = this.dao.agencyCode;
    userData.PolicyNumber = this.currentPolicy.policyNumber;
    userData.InsuredName = this.dao.insuredName;
    userData.ProgressToPage = window.localStorage.getItem("policyType");
    let payloadDetail:any={}; 
    payloadDetail.endPointURL =await this.serviceLayer.getEndPoint("ManagePolicy", "PolicyDetails", [this.dao.loginUserDetail.userCompany,policyDetails.policyNumber,50]);
    payloadDetail.payload = "";
    payloadDetail.response = this.policyDetails;
    userData.Payload = JSON.stringify(payloadDetail);
    userData.TransactionStatus = "Success";
    userData.RateOnly = false;
    userData.ActionType = "Load Cancel Policy Details"; 
    await this.serviceLayer.postUserActivity(userData);
  }
  public cancelledPolicy:string='';
  async pushCancelDetails(policy) {
    this.currentPolicy.isClaimFound = this.isClaimFound;
    this.currentPolicy.isPendingAmendment = this.isPendingAmendment; 
    this.currentPolicy.referenceNumber = this.currentPolicy.referenceNumber === '' ? null : this.currentPolicy.referenceNumber;   
    var element = document.getElementById("UpdateID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    let response = await this.serviceLayer.cancelationDetail(this.cancelPopupDetails, this.currentPolicy,false,policy?.totalPremiumAmount);
    if (!response) {
      this.dao.policyNumber = this.currentPolicy.policyNumber;
      $("#cancelModal").modal('hide');
      this.IsCancel = true;      
      this.cancelledPolicy = this.dao.policyNumber;     
      this.isBPMiAmend = this.dao.closedPopupModel.isBPmiAmendment == true;
      this.dao.closedPopupModel.isShowError = false;
      this.dao.closedPopupModel.cancelReasonCdModal = null;
      this.dao.closedPopupModel.cancelOCP = false;
      this.popUpClose(this.policyDetails);
    }
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
    return response;
  }

  async policyChangeRequest(policy,id,from:string='') { 
    this.ActiveIndex = id;
    this.showExtendBPMi = false;
    var element = document.getElementById("card"+id);
    if(this.lastActive != undefined && this.lastActive != null) {
      var last = document.getElementById(this.lastActive);
      last != undefined ? last.classList.remove("focuscard") : null; 
      if(element != undefined && element != null) {
        element.classList.add("focuscard");
      }
      this.lastActive = "card"+id;
    }
    else {
      if(element != undefined && element != null) {
        element.classList.add("focuscard");
      }
      this.lastActive = "card"+id;
    }
    this.tempCurrentPolicy = policy;
    this.isCancelExpired = this.statusChecks.includes(this.tempCurrentPolicy?.status.toUpperCase());
    this.validateAddress = true;
    this.IsPolicyExtensionEnable = true;
    this.policyChangeModal = policy;
    this.canAmendData = {};  
    if(this.policyChangeModal?.policyAmendments?.length > 0){
      this.policyChangeModal?.policyAmendments?.forEach(c=>{        
        this.canAmendData[c.amendType] = c.canAmend;
      });
    }  
    this.currentPolicyDetails = await this.serviceLayer.getcurrentPolicyDetails(this.policyChangeModal.companyCode, this.policyChangeModal.policyNumber);
    if(this.currentPolicyDetails?.policyAmendments?.length > 0){
      this.currentPolicyDetails?.policyAmendments?.forEach(c=>{
        if(c.amendType == "extendPolicyTerm"){
          this.IsPolicyExtensionEnable = c.isPolicyExtensionAllowed;
        }      
      });
    }
    var element = document.getElementById("GettingID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    this.policyRequestLabels = await this.serviceLayer.getPolicyRequestLabels();
    await this.getBPMIFields(policy.policyNumber);
    this.policyDetails = await this.serviceLayer.getPolicyDetails(policy.policyNumber,policy.policyMod);
    var todayDate=new Date();
    let currentDate =this.datepipe.transform(todayDate, 'yyyy-MM-dd');
    this.eventDetails=await this.serviceLayer.getEvents(currentDate);
    if(this.eventDetails!=undefined && this.eventDetails!=null && this.eventDetails?.message!=undefined && this.eventDetails?.message!=null){
      this.IsPolicyEvent=false;
      this.eventDetails.message.forEach(item =>
        {   
          if(this.IsPolicyEvent==false){
           // var eventLocations = item.States.Split(',');
            var eventLocations=item.States.split(',').map(text => { return text.trim() });
            eventLocations.forEach(async us =>{
              if(this.policyDetails.clientInfo.jobsiteAddress[0].state==us){
                this.countiesDetails = await this.serviceLayer.getCountyByStateCode(us);
                if(this.countiesDetails != undefined && this.countiesDetails != null)
                {
                  this.countiesDetails.message.forEach(stateCounties =>{
                    if(this.policyDetails.clientInfo.jobsiteAddress[0].county.toUpperCase() == stateCounties.counties.toUpperCase()){
                      this.IsPolicyEvent=true; 
                      this.eventReason= item.EventReason.toString(); 
                    }                   
                  })
                }
                else{
                  this.IsPolicyEvent=true; 
                  this.eventReason= item.EventReason.toString(); 
                }                            
              }
            });
          }
        });     
    }
    
    await this.getClaimAndPendingAmendFound();
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
     this.DeductibleList = this.onChangeDeductibleValue();
    this.templimits["DeductibleList"] = this.DeductibleList;
    if(this.policyDetails?.policyDetails?.earthQuake?.earthquakeLimitOptions == null) {
      this.EQList = [];
      this.templimits["EQList"] = [];
    }
    else {
      this.EQList = this.policyDetails?.policyDetails?.earthQuake?.earthquakeLimitOptions;
      this.templimits["EQList"] = this.policyDetails?.policyDetails?.earthQuake?.earthquakeLimitOptions;
    }
    if(this.policyDetails?.policyDetails?.flood?.floodLimitOptions == null) {
      this.FloodList = [];
      this.templimits["FloodList"] = [];
    }
    else {
      this.FloodList = this.policyDetails?.policyDetails?.flood?.floodLimitOptions;
      this.templimits["FloodList"] = this.policyDetails?.policyDetails?.flood?.floodLimitOptions;
    }
    this.PolicyOptions = Object.values(this.policyRequestLabels?.policyOptions);
    var res = this.policyDetails?.jobSiteOptionLimits?.jobSiteMaxLimitMsg;
    if(res != undefined) {
      var list = res.split("$");
      this.ProjectLimitLabel = list[0];
      this.projectLimitTotal = list[1];
    }
    if(this.policyDetails?.jobSiteOptionLimits != undefined) {
      this.policyDetails['jobSiteOptionLimits']['jobSiteMaxLimit'] = Number (this.policyDetails?.jobSiteOptionLimits?.jobSiteMaxLimit);
      this.policyDetails['jobSiteOptionLimits']['jobSiteMinLimit'] = Number (this.policyDetails?.jobSiteOptionLimits?.jobSiteMinLimit);
    }
    this.policyChangeValue = true;
    this.dao.agencyCode = this.policyDetails?.agencyInfo?.code;
    this.dao.policyNumber = this.tempCurrentPolicy?.policyNumber;
    this.dao.insuredName = this.tempCurrentPolicy?.nameInsured;
    if(from == 'btnclick'){
      this.postUserActivity(this.policyDetails,'Success',0,"Open Policy Details","ManagePolicy", "PolicyDetails",[this.dao.loginUserDetail.userCompany,this.dao.policyNumber,50]);
    }
  }

  async editProjectAddress() {
    this.isConfirmBPMiChange = false;
    this.isConfirmBPMi = false;
    var element = document.getElementById("GettingID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    this.ProjectQuestionaire = await this.serviceLayer.getPolicyQuestionnaire("updateJobsiteAddress");    
    this.ProjectAddressInfo.addressId = this.policyDetails?.clientInfo?.jobsiteAddress[0].addressID;
    this.ProjectAddressInfo.streetNo = '';
    this.ProjectAddressInfo.address1 = (this.policyDetails?.clientInfo?.jobsiteAddress[0].addressNo ? (this.policyDetails?.clientInfo?.jobsiteAddress[0].addressNo + ' ') : '') +this.policyDetails?.clientInfo?.jobsiteAddress[0].addressLine1;
    this.ProjectAddressInfo.city = this.policyDetails?.clientInfo?.jobsiteAddress[0].city;
    this.ProjectAddressInfo.state = this.policyDetails?.clientInfo?.jobsiteAddress[0].state;
    this.ProjectAddressInfo.zip = this.policyDetails?.clientInfo?.jobsiteAddress[0].zip;
    this.ProjectAddressInfo.isAddressNoEdit = false;
    this.ProjectAddressInfo.isAddress1Edit = false;
    this.tempProjectAddressInfo = _.cloneDeep(this.ProjectAddressInfo);
    this.EditProject = true; 
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    } 
    this.isClosed = false;  
  }
  public UndoProjectAddress(type){
    this.ProjectAddressInfo[type] = _.cloneDeep(this.tempProjectAddressInfo[type]);
  }
  public isProjectSubmitDisabled(){
    if(this.ProjectAddressInfo.address1 != this.tempProjectAddressInfo.address1 || 
      this.ProjectAddressInfo.city != this.tempProjectAddressInfo.city ||
      this.ProjectAddressInfo.state != this.tempProjectAddressInfo.state ||
      this.ProjectAddressInfo.zip != this.tempProjectAddressInfo.zip){
        return false;
      }
      return true;
  }

  closeProjectAddress() {
    this.EditProject = false;
    this.SelectedAddress = false;
  }

  async editMailingAddress() {
    this.autocompleteInput = null;
    this.EditMailing = true;
    var element = document.getElementById("GettingID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    this.MailingQuestionnaire = await this.serviceLayer.getPolicyQuestionnaire("updateMailingAddress");
    let countyValue = this.policyDetails?.clientInfo?.mailingAddress[0]?.county;
    if(countyValue == undefined || countyValue == null || countyValue.length<3) {
      countyValue = "ABC";
    }
    this.MailingForm = {
      "addressId":this.policyDetails?.clientInfo?.mailingAddress[0]?.addressID,
      "streetNo":'',
      "address1":(this.policyDetails?.clientInfo?.mailingAddress[0]?.addressNo ? (this.policyDetails?.clientInfo?.mailingAddress[0]?.addressNo + ' ') : '') + this.policyDetails?.clientInfo?.mailingAddress[0]?.addressLine1,
      "city":this.policyDetails?.clientInfo?.mailingAddress[0]?.city,
      "state":this.policyDetails?.clientInfo?.mailingAddress[0]?.state,
      "county":countyValue,
      "postalCode":this.policyDetails?.clientInfo?.mailingAddress[0]?.zip
    }
    this.MailEdit={
      "showstreetNo":true,
      "showaddress1":true,
      "showcity":true,
      "showcounty":true,
      "showstate":true,
      "showpostalCode":true
    };
    this.tempMailingForm = _.cloneDeep(this.MailingForm);
    var mailQuestionnaire = this.jp.query(this.MailingQuestionnaire.questionnaire,"$..[?(@.key == 'AddressInfo')]")[0].questionAnswer;
    this.stateList = this.jp.query(mailQuestionnaire,"$..[?(@.key == 'state')]")[0].questionOptions;
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
  }

  UpdateMailingAddress() {
    this.autocompleteInput=null;
    this.ShowEditMailView=true;
    this.BillingEdit={
      "showstreetNo":true,
      "showaddress1":true,
      "showcity":true,
      "showcounty":true,
      "showstate":true,
      "showpostalCode":true
    };
    this.MailingForm = _.cloneDeep(this.tempMailingForm);
  }

  validateMailUpdate() {
    if(this.MailingType == "NewMailingAddress") {
      if(_.isEqual(this.MailingForm,this.tempMailingForm)) {
        return true;
      }
      else {
        if(this.MailingForm?.county != undefined && this.MailingForm?.county != null && this.MailingForm?.county?.length<3) {
          return true;
        }
        return false;
      }
    }
    else {
      return true;
    }
  }

  undoMailEdit(property) {
    this.MailingForm[property] = this.tempMailingForm[property];
    this.MailEdit['show'+property] = true;
  }

  undoBillingEdit(property) {
    this.BillingAddressInfo[property] = this.tempBillingAddressInfo[property];
    this.BillingEdit['show'+property] = true;
  }

  closeMailingAddress() {
    this.MailingType = 'NewMailingAddress';
    this.autocompleteInput = null;
    this.validateAddress = true;
    this.EditMailing = false;
    this.closeMailEdit();
  }

  closeFinancialInterest() {
    this.ViewFinancial = false;
  }

  UseProjectAddress() {   
    this.autocompleteInput = (this.policyDetails?.clientInfo?.jobsiteAddress[0].addressNo ? (this.policyDetails?.clientInfo?.jobsiteAddress[0].addressNo + ', ') : '') +
      this.policyDetails?.clientInfo?.jobsiteAddress[0].addressLine1 + ', ' +
      this.policyDetails?.clientInfo?.jobsiteAddress[0].city + ', ' +
      this.policyDetails?.clientInfo?.jobsiteAddress[0].state + ' ' +
      this.policyDetails?.clientInfo?.jobsiteAddress[0].zip;
    this.MailingType = 'ProjectAddress';
    let countyValue = this.policyDetails?.clientInfo?.jobsiteAddress[0]?.county;
    if(countyValue == undefined || countyValue == null || countyValue.length<3) {
      countyValue = "ABC";
    }
    this.MailingForm = {
      "addressId":this.policyDetails?.clientInfo?.jobsiteAddress[0]?.addressID,
      "streetNo":'',
      "address1":(this.policyDetails?.clientInfo?.jobsiteAddress[0]?.addressNo ? (this.policyDetails?.clientInfo?.jobsiteAddress[0]?.addressNo + ' ') : '') + this.policyDetails?.clientInfo?.jobsiteAddress[0]?.addressLine1,
      "city":this.policyDetails?.clientInfo?.jobsiteAddress[0]?.city,
      "state":this.policyDetails?.clientInfo?.jobsiteAddress[0]?.state,
      "county":countyValue,
      "postalCode":this.policyDetails?.clientInfo?.jobsiteAddress[0]?.zip
    }
  }

  popUpClose(event) {
    this.showCancelPopup = false;
    this.showPolicyConfirm = this.IsCancel;        
    this.isClosed = false;
    this.IsCancel = false;
    if (this.PolicyQuotesList.length > 0) {
      var currentPolicy = this.PolicyQuotesList.filter(x => x.policyNumber == event.policyNumber);
    }
    currentPolicy[0].value = null;
    $("#cancelModal").modal('hide');
  }

  filterPolicy() {
    this.IsOpen = false;
    this.filteredList = [];
    if (this.PolicyorName != "" && this.PolicyorName != null && this.PolicyorName.length > 2 && this.tempPolicyList != undefined && this.tempPolicyList != null && this.tempPolicyList.length>0) {
      this.PolicyQuotesList = this.tempPolicyList.filter(policy => policy.typeName == 'Policy' && (((policy.policyNumber != null) && (policy.policyNumber).toLowerCase().includes(this.PolicyorName)) || ((policy.nameInsured != null) && policy.nameInsured.toLowerCase().includes(this.PolicyorName.toLowerCase()))));
      if (this.PolicyQuotesList.length > 0) {
        this.filteredList = this.PolicyQuotesList.slice(0, 10);
      }
    }
    else {
      this.filteredList = [];
    }
  }

  paginate(event) {
    this.filteredList = this.PolicyQuotesList.slice((event.page) * 10, (event.page) * 10 + 10);
  }

  CreateOnlineQuote() {
    let quoteURL = this.settings.quickQuotePolicyUrl + 'Questions/BFM/BR/';
    window.open(quoteURL);
  }
  clickDocument(){
    this.serviceLayer.openLink('documentCenter','',this.policyDetails?.policyNumber);
  }

  searchPolicy() {
    this.policyNumber = this.policyNumber.trim();
    if (this.policyNumber.length == 7) {
      this.showPolicyError = false;
    }
    else {
      this.showPolicyError = true; 
    }
  }

  clearPolicy() {
    this.policyNumber = '';
    this.showPolicyError = false;
  }

  ValidateZip(value) {
    if (this.ZipValue.toString().length > 5) {
      this.ZipValue = this.ZipValue / 10 | 0;
    }
  }
  get f() { return this.OverWriteForm?.controls; }

  get e() { return this.EffectiveForm?.controls; }

  async OverWriteSubmit(form: NgForm) {

    this.submitted = true;
    if (this.OverWriteForm.invalid) {
      return;
    }
    //await this.ValidateAddresss(this.ProjectAddressValue,form);
    this.submitted = false;
    this.OnErrorAddress = false;
    this.SelectedAddress = true;
  }

  async AddNewMailAddress() {
    var Questionnaire = _.cloneDeep(this.MailingQuestionnaire);
    var amendQuestionnaire = this.jp.query(Questionnaire.questionnaire,"$..[?(@.key == 'AmendQuestionnare')]")[0].questionAnswer;
    var AmendLabels = {
      "policyId":this.policyDetails?.policyId,
      "amendEffectiveDate":this.datepipe.transform(new Date(), 'yyyy-MM-dd'),
      "amendType":"updateMailingAddress",
      "amendReasonCd":"MAIL_ADR"
    }
    amendQuestionnaire.forEach(element => {
      if(AmendLabels[element.key] != undefined) {
        element.answer = AmendLabels[element.key];
      }
    });
    var addressQuestionnaire = this.jp.query(Questionnaire.questionnaire,"$..[?(@.key == 'AddressInfo')]")[0].questionAnswer;
    addressQuestionnaire.forEach(element => {
      if(this.MailingForm[element.key] != undefined) {
        element.answer = this.MailingForm[element.key];
        element.propertyName = 'MaillingAddress';
        element.isChanged = this.MailingForm[element.key] != this.tempMailingForm[element.key];
      }
    });
    var element = document.getElementById("UpdateID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    if(this.jp.query(Questionnaire,"$..[?(@.key == 'amendReasonText')]")?.length > 0){
      this.jp.query(Questionnaire,"$..[?(@.key == 'amendReasonText')]")[0].answer = await this.getAmendDesc("Address",Questionnaire);
    }
    let previousValue={
      'PropertyID':this.tempMailingForm.addressId,
      'PropertyValue':this.tempMailingForm.address1+','+this.tempMailingForm.city+','+this.tempMailingForm.state+','+this.tempMailingForm.postalCode
    }
    let amendResponse:any = await this.serviceLayer.SubmitMailingAddress(Questionnaire,previousValue,this.policyDetails.referenceNumber,this.policyDetails?.policyNumber,this.isClaimFound,this.isPendingAmendment,this.policyDetails?.clientInfo?.insuredName,this.tempCurrentPolicy?.productCode,this.datepipe.transform(this.tempCurrentPolicy?.effectiveDate, 'yyyy-MM-dd'),this.datepipe.transform(this.tempCurrentPolicy?.expireDate, 'yyyy-MM-dd'),this.tempCurrentPolicy?.noOfAmendmentsMade,this.tempCurrentPolicy?.policyMod);
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
    this.isBPMiAmend = amendResponse?.isBPMiAmendment == true;
    this.showPolicyConfirm = true;
    this.isClosed = false;
  }

  EditNewAddress() {
    var elements = this.autocompleteInput.split(',');
    this.tempMailValue = this.autocompleteInput;
    this.ShowEditMailView = true;
  }

  async UpdateProjectAddress() {
    if(this.ProjectAddressInfo.address1 == null || this.ProjectAddressInfo.address1 == ''){

    }
    else{
      var Questionnaire = _.cloneDeep(this.ProjectQuestionaire);
      var amendQuestionnaire = this.jp.query(Questionnaire.questionnaire,"$..[?(@.key == 'AmendQuestionnare')]")[0].questionAnswer;
      var AmendLabels = {
        "policyId":this.policyDetails?.policyId,
        "amendEffectiveDate":this.datepipe.transform(new Date(), 'yyyy-MM-dd'),
        "amendType":"updateJobsiteAddress",
        "amendReasonCd":"PROP_DESC",
      }
      amendQuestionnaire.forEach(element => {
        if(AmendLabels[element.key] != undefined) {
          element.answer = AmendLabels[element.key];
        }
      });
      var addressQuestionnaire = this.jp.query(Questionnaire.questionnaire,"$..[?(@.key == 'JobsiteAddrInfo')]")[0].questionAnswer;
      addressQuestionnaire.forEach(element => {
        if(this.ProjectAddressInfo[element.key] != undefined) {
          element.answer = this.ProjectAddressInfo[element.key];
          element.propertyName = 'ProjectAddress';
          element.isChanged = this.ProjectAddressInfo[element.key] != this.tempProjectAddressInfo[element.key];
        }
      });
      var element = document.getElementById("UpdateID");
      if(element != undefined && element != null) {
        element.classList.add("calculateLbl");
      }
      if(this.jp.query(Questionnaire,"$..[?(@.key == 'amendReasonText')]")?.length > 0){
        this.jp.query(Questionnaire,"$..[?(@.key == 'amendReasonText')]")[0].answer = await this.getAmendDesc("ProjectAddress",Questionnaire);
      }  
      let previousValue={
        'PropertyID':this.tempProjectAddressInfo.addressId,
        'PropertyValue':this.tempProjectAddressInfo.address1
      }    
      let amendResponse:any = await this.serviceLayer.SubmitMailingAddress(Questionnaire,previousValue,this.policyDetails.referenceNumber,this.policyDetails?.policyNumber,this.isClaimFound,this.isPendingAmendment,this.policyDetails?.clientInfo?.insuredName,this.tempCurrentPolicy?.productCode,this.datepipe.transform(this.tempCurrentPolicy?.effectiveDate, 'yyyy-MM-dd'),this.datepipe.transform(this.tempCurrentPolicy?.expireDate, 'yyyy-MM-dd'),this.tempCurrentPolicy?.noOfAmendmentsMade,this.tempCurrentPolicy?.policyMod);
      if(element != undefined && element != null) {
        element.classList.remove("calculateLbl");
      }
      this.isBPMiAmend = amendResponse?.isBPMiAmendment == true;
      this.showPolicyConfirm = true;
      this.closeProjectAddress();
    }
  }

  closeMailEdit() {
    this.MailSubmitted = false;
    this.autocompleteInput = this.tempMailValue;
  }

  async PolicyDetailsSubmit() {
    if(this.ProjectLimitValue >= this.originalProjectLimit){
      var data = {
        "jobSiteUnitCommonId":this.policyDetails.jobSiteUnitCommandId,
        "jobSiteLimit":this.ProjectLimitValue,
        "unitCommonId":this.policyDetails.unitCommandId,
        "eqLimit":this.policyDetails?.policyDetails?.earthQuake?.limit != 0 ? this.EQValue : this.policyDetails?.policyDetails?.earthQuake?.limit,
        "floodLimit":this.policyDetails?.policyDetails?.flood?.limit != 0 ? this.floodValue : this.policyDetails?.policyDetails?.flood?.limit,
        "deductible":this.deductibleValue,
        "amendReasonCd":(this.amendReason != undefined && this.amendReason.length>0?this.amendReason.join():null),
        "policyId":this.policyDetails.policyId,
        "amendType":"updateCoverage",
        "rateOnly":true,
        "amendEffectiveDate":this.datepipe.transform(this.policyDetails?.policyStartDate,"yyyy-MM-dd")
      }
      var element = document.getElementById("calculateID");      
      element != undefined ? element.classList.add("calculateLbl") : null;
      var prevValue = {
        "jobSiteUnitCommonId":this.policyDetails.jobSiteUnitCommandId,
        "jobSiteLimit":this.tempProjectLimitValue,
        "unitCommonId":this.policyDetails.unitCommandId,
        "eqLimit":this.policyDetails?.policyDetails?.earthQuake?.limit != 0 ? this.tempEQNumber : this.policyDetails?.policyDetails?.earthQuake?.limit,
        "floodLimit":this.policyDetails?.policyDetails?.flood?.limit != 0 ? this.tempFloodNumber : this.policyDetails?.policyDetails?.flood?.limit,
        "deductible":this.tempDeductibleNumber,
        "amendReasonCd":(this.amendReason != undefined && this.amendReason.length>0?this.amendReason.join():null),
        "policyId":this.policyDetails.policyId,
        "amendType":"updateCoverage",
        "rateOnly":true,
        "amendEffectiveDate":this.datepipe.transform(this.policyDetails?.policyStartDate,"yyyy-MM-dd")
      }
      if(this.jp.query(this.coverageQuestionnaire,"$..[?(@.key == 'amendReasonText')]")?.length > 0){
        this.jp.query(this.coverageQuestionnaire,"$..[?(@.key == 'amendReasonText')]")[0].answer = await this.getAmendDesc("Coverage",this.coverageQuestionnaire);
      }
      let previousValue = {
        'ProjectLimit':this.policyDetails?.jobsiteLimit.replace('$', ''),
        'Deductible':this.policyDetails?.policyDetails?.deductibleValue,
        'Flood':this.policyDetails?.policyDetails?.flood?.limitValue,
        'EarthQuake':this.policyDetails?.policyDetails?.earthQuake?.limitValue
      }
      await this.serviceLayer.SubmitPolicyCoverage(this.coverageQuestionnaire,data,previousValue,this.policyDetails.referenceNumber,this.policyDetails?.policyNumber,this.isClaimFound,this.isPendingAmendment,prevValue,this.policyDetails?.clientInfo?.insuredName,this.tempCurrentPolicy?.productCode,this.datepipe.transform(this.tempCurrentPolicy?.effectiveDate, 'yyyy-MM-dd'),this.datepipe.transform(this.tempCurrentPolicy?.expireDate, 'yyyy-MM-dd'),this.tempCurrentPolicy?.noOfAmendmentsMade,this.tempCurrentPolicy?.policyMod).then(async(response)=>{
           if (response?.success?.toLowerCase() === 'false') {
            this.policyLockMessage = response?.message;
            this.showPolicyLockPopup = true;
            return;
        }
        element != undefined ? element.classList.remove("calculateLbl") : null;
        this.showPremium = true;
        this.premiumValue = response.policyTotalPremium;
        this.amendPremiumValue = response.amendPremium;
        this.submitType = "policyLimits";
      });
    }
  }
  checkPositiveAmendPremium(){
    if(Number(this.amendPremiumValue) >= 0){
      return true;
    }
    return false;
  }

  closeEditPolicy() {
    this.policyDetailForm.reset({});
    this.policyDetailForm.submitted = false;
    this.PolicySubmitted = false;
    this.onEditPolicy=false;
  }

  async editPolicyDetails() {
    this.isConfirmBPMiChange = false;
    this.isConfirmBPMi = false;
    var element = document.getElementById("GettingID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    this.coverageQuestionnaire = await this.serviceLayer.getPolicyCoverage();
    this.ProjectLimitValue = this.policyDetails?.jobsiteLimit.replace('$', '');
    if(this.ProjectLimitValue != undefined) {
      this.ProjectLimitValue = parseInt(this.ProjectLimitValue.replaceAll(',',''));
      this.tempProjectLimitValue = this.ProjectLimitValue;
      this.originalProjectLimit = this.ProjectLimitValue;
    }
    this.deductibleValue = this.policyDetails?.policyDetails?.deductibleValue;
    this.tempDeductibleNumber = this.deductibleValue;
    this.floodValue = this.policyDetails?.policyDetails?.flood?.limitValue;
    this.tempFloodNumber = this.floodValue;
    this.EQValue = this.policyDetails?.policyDetails?.earthQuake?.limitValue;
    this.tempEQNumber = this.EQValue;
    var amendQuestionnaire = this.jp.query(this.coverageQuestionnaire,"$..[?(@.key == 'AmendQuestionnare')]")[0].questionAnswer;
    this.ReasonList = this.jp.query(amendQuestionnaire,"$..[?(@.key == 'amendReasonCd')]")[0].questionOptions;
    this.showProjectEdit = true;
    this.showdeductibleEdit = true;
    this.showFloodEdit = true;
    this.showEQEdit = true;
    this.showDescription = true;
    this.showReason = true;
    this.onEditPolicy = true;
    this.isAcceptJobsiteLimit = false;
    this.amendReason = [];
    this.FloodList = this.templimits["FloodList"];
    this.DeductibleList = this.templimits["DeductibleList"];
    this.EQList = this.templimits["EQList"];
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
    this.disabledFloodEQoptions();
  }

  ValidateProjectLimit(event) {
    this.ProjectLimitValue = event.value;
    if(this.ProjectLimitValue != undefined && this.ProjectLimitValue != null) {
      var max = this.policyDetails.jobSiteOptionLimits?.jobSiteMaxLimit;
      var min = this.policyDetails.jobSiteOptionLimits?.jobSiteMinLimit;
      if(this.policyDetails.jobSiteOptionLimits != undefined && this.ProjectLimitValue>max) {
        this.validateMaxProject = true;
        this.validateMinProject = false;
      }
      else if(this.policyDetails.jobSiteOptionLimits != undefined && this.ProjectLimitValue<=min){
        this.validateMinProject = true;
        this.validateMaxProject = false;
      }
      else {
        this.validateMaxProject = false;
        this.validateMinProject = false;
      }
    }
    else {
      this.validateMaxProject = false;
      this.validateMinProject = false;
    }
  }

  async calculateOption(isExtendPolicies : any){
    this.IsPolicyExtensionAllowed = (isExtendPolicies.toUpperCase() == "YES" ? false : true );
    if(this.IsPolicyExtensionAllowed)
    {
    this.isConfirmBPMiChange = false;
    this.isConfirmBPMi = false;
    this.showExpiration = true;
    if(this.tempCurrentPolicy?.effectiveDate>=this.dao.PriorEffectiveDate){
      this.ExtendPolicyPriorEffectiveDate = true;
    }
    else {
      this.ExtendPolicyPriorEffectiveDate = false;
    }
    this.effectiveDate=this.datepipe.transform(this.policyDetails?.policyStartDate,"MM/dd/yyyy");
    this.expirationDate = this.datepipe.transform(this.policyDetails?.policyEndDate,"MM/dd/yyyy");
    this.tempExpirationDate = this.expirationDate;
    this.maxDate = new Date(this.policyDetails?.policyEndDate);
    // if(this.tempCurrentPolicy?.status == "Expired" && this.tempCurrentPolicy?.canExtend){
    //   this.maxDate.setDate(this.maxDate.getDate()+5);
    // }
    this.year = _.cloneDeep(this.maxDate.getFullYear());
    this.maxyear = _.cloneDeep(this.year + 2);
    
		// Existing Behaviour for Extension selection Period
    // var month = this.maxDate.getMonth();
    // var day = this.maxDate.getDate();
    // this.currentExpirationDate = new Date(this.policyDetails?.policyEndDate);
    // this.MaxExpirationDate = new Date(new Date(this.maxyear, month, day));
    
    // updated to select the extension period must be between 90 and 365 days as per BFMIT-61.
    const minDate = new Date(this.policyDetails?.policyEndDate);
    minDate.setDate(minDate.getDate() + 90);
    this.currentExpirationDate = minDate;

    const maxDate = new Date(this.policyDetails?.policyEndDate);
    maxDate.setDate(maxDate.getDate() + 365);
    this.MaxExpirationDate = maxDate;

    const exceedDays = this.HasExceedExtentioPeriod(this.currentExpirationDate);
    this.IsPolicyPeriodExtensionReached = exceedDays > 730;
    this.IsExceedExtentioPeriod = this.IsPolicyPeriodExtensionReached;

    this.editEffective = true;
    this.editQuestion = false;
    this.EffectiveForm = this.formBuilder.group({
      effectiveDate: [this.datepipe.transform(this.policyDetails?.policyStartDate,"MM/dd/yyyy")],
      expirationDate: [this.datepipe.transform(this.policyDetails?.policyEndDate,"MM/dd/yyyy")]
    });
    var element = document.getElementById("GettingID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    this.ExtendTermQuestionnaire = await this.serviceLayer.getPolicyQuestionnaire('extendPolicyTerm');
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }  
    }else{
      this.ExtendTermQuestionnaire = await this.serviceLayer.getPolicyQuestionnaire('extendPolicyTerm');
      let AmendQuestionnareData = jsonPathRef.query(this.ExtendTermQuestionnaire, "$..[?(@.key == 'AmendQuestionnare')].questionAnswer")[0];
      let ExtendTermData = jsonPathRef.query(this.ExtendTermQuestionnaire, "$..[?(@.key == 'ExtendTerm')].questionAnswer")[0];
      if(AmendQuestionnareData && AmendQuestionnareData?.length > 0){
       AmendQuestionnareData.forEach(extend=>{
        if(extend.key == 'policyId'){
          extend.answer = this.policyDetails?.policyId;
        }      
        else if(extend.key == 'amendType'){
          extend.answer = 'Denied';
        }
      })
    }
    if(ExtendTermData && ExtendTermData?.length > 0){
      ExtendTermData.forEach(extend=>{
        if(extend.key == 'expirationDate'){
          extend.answer = "Denied";
          extend.propertyName = 'Denied';
          extend.isChanged = true;
        }
      });
      // Add nonRenewable status in ExtendTerm Questionnaire
      var nonRenewableData:any = {};
      nonRenewableData.key = "nonRenewable";
      nonRenewableData.answer = this.policyDetails.nonRenewable;
      ExtendTermData.push(nonRenewableData);
    }
    var element = document.getElementById("calculateID");
    element != undefined ? element.classList.add("calculateLbl") : null;   
    if(this.jp.query(this.ExtendTermQuestionnaire,"$..[?(@.key == 'amendReasonText')]")?.length > 0){
      this.jp.query(this.ExtendTermQuestionnaire,"$..[?(@.key == 'amendReasonText')]")[0].answer = await this.getAmendDesc("extendTerm",this.ExtendTermQuestionnaire);
    } 
      var response = await this.serviceLayer.policyDenied(this.ExtendTermQuestionnaire,'',false,this.policyDetails.referenceNumber,this.policyDetails?.policyNumber,this.isClaimFound,this.isPendingAmendment,this.policyDetails?.clientInfo?.insuredName,this.tempCurrentPolicy?.productCode,this.datepipe.transform(this.tempCurrentPolicy?.effectiveDate, 'yyyy-MM-dd'),this.datepipe.transform(this.tempCurrentPolicy?.expireDate, 'yyyy-MM-dd'),this.tempCurrentPolicy?.noOfAmendmentsMade,this.tempCurrentPolicy?.policyMod);
      if(response)
      {
        this.editQuestion = false;
        this.IsPolicyExtensionEnable = false;
        this.closeEffective = true;
      }
      
    }

  }
   async closePopUpConfirmation(){
    this.editQuestion = false;
    this.IsPolicyExtensionEnable = false;
    this.closeEffective = false;
   }

  async showQuestionPage(){
    this.editQuestion = true;
    this.isExtendPolicies = null;
  }
  closePolicyLockPopup() {
  this.showPolicyLockPopup = false;
  this.editEffective = false;
  this.onEditPolicy = false;
}

   async calculateChange(){
    debugger;
    let AmendQuestionnareData = jsonPathRef.query(this.ExtendTermQuestionnaire, "$..[?(@.key == 'AmendQuestionnare')].questionAnswer")[0];
    let ExtendTermData = jsonPathRef.query(this.ExtendTermQuestionnaire, "$..[?(@.key == 'ExtendTerm')].questionAnswer")[0];
    if(AmendQuestionnareData && AmendQuestionnareData?.length > 0){
      AmendQuestionnareData.forEach(extend=>{
        if(extend.key == 'policyId'){
          extend.answer = this.policyDetails?.policyId;
        }
        else if(extend.key == 'amendEffectiveDate'){
          extend.answer = this.datepipe.transform(this.policyDetails?.policyStartDate,"yyyy-MM-dd");
        }
        else if(extend.key == 'amendType'){
          extend.answer = 'extendPolicyTerm';
        }
        else if(extend.key == 'amendReasonCd') {
          extend.answer = 'EFF_EXP_DT';
        }
        // else if(extend.key == 'amendReasonText') {
        //   extend.answer = 'Policy expiration date is amended to read '+this.datepipe.transform(new Date(this.datepipe.transform((this.expirationDate), 'MM-dd-yyyy')), 'yyyy-MM-dd')+'. ALL OTHER POLICY TERMS AND CONDITIONS REMAIN THE SAME *Print Dec Page. Indicate Reprint';
        // }
      })
    }
    if(ExtendTermData && ExtendTermData?.length > 0){
      ExtendTermData.forEach(extend=>{
        if(extend.key == 'expirationDate'){
          extend.answer = this.datepipe.transform(new Date(this.datepipe.transform((this.expirationDate), 'MM-dd-yyyy')), 'yyyy-MM-dd');
          extend.propertyName = 'ExpirationDate';
          extend.isChanged = this.expirationDate != this.tempExpirationDate;
        }
      });
      // Add nonRenewable status in ExtendTerm Questionnaire
      var nonRenewableData:any = {};
      nonRenewableData.key = "nonRenewable";
      nonRenewableData.answer = this.policyDetails.nonRenewable;
      ExtendTermData.push(nonRenewableData);
    }
    var element = document.getElementById("calculateID");
    element != undefined ? element.classList.add("calculateLbl") : null;   
    if(this.jp.query(this.ExtendTermQuestionnaire,"$..[?(@.key == 'amendReasonText')]")?.length > 0){
      this.jp.query(this.ExtendTermQuestionnaire,"$..[?(@.key == 'amendReasonText')]")[0].answer = await this.getAmendDesc("extendTerm",this.ExtendTermQuestionnaire);
    }
    this.submitType = "ExtendTerm";
    if(!this.ExtendPolicyPriorEffectiveDate) {
      this.PremiumSubmit();
    }
    else {
      let response = await this.serviceLayer.savePremium(this.ExtendTermQuestionnaire,'',true,this.policyDetails.referenceNumber,this.policyDetails?.policyNumber,this.isClaimFound,this.isPendingAmendment,this.policyDetails?.clientInfo?.insuredName,this.tempCurrentPolicy?.productCode,this.datepipe.transform(this.tempCurrentPolicy?.effectiveDate, 'yyyy-MM-dd'),this.datepipe.transform(this.tempCurrentPolicy?.expireDate, 'yyyy-MM-dd'),this.tempCurrentPolicy?.noOfAmendmentsMade,this.tempCurrentPolicy?.policyMod);
      
   if (response?.success === 'false') {
      this.policyLockMessage = response?.message;
      this.showPolicyLockPopup = true;
      this.showPremium = false;
      return;
    }

      this.showPremium=true;
      if(response != null) {
        this.amendPremiumValue = response['amendPremium'] != undefined ? response['amendPremium']:null;
        this.premiumValue = response['policyTotalPremium'] != undefined ? response['policyTotalPremium']:null;
      }
    }
    element != undefined ? element.classList.remove("calculateLbl") : null;
}
  
  closePolicyEff(effective:NgForm) {
    effective.reset({});
    this.EffectiveSubmitted = false;
    this.editEffective = false;
    this.editQuestion = false;
    this.closeEffective = true;
  }

  UpdateEffective(effective:NgForm) {
    this.EffectiveSubmitted = true;
    if (this.EffectiveForm.invalid) {
      return;
    }
    this.closePolicyEff(effective);
  }

  async PremiumSubmit() {
    debugger;
    var element = document.getElementById("UpdateID");
    let amendResponse:any = {};
    if(this.submitType =="ExtendTerm") {
      element != undefined ? element.classList.add("calculateLbl") : null;
      amendResponse = await this.serviceLayer.savePremium(this.ExtendTermQuestionnaire,'',false,this.policyDetails.referenceNumber,this.policyDetails?.policyNumber,this.isClaimFound,this.isPendingAmendment,this.policyDetails?.clientInfo?.insuredName,this.tempCurrentPolicy?.productCode,this.datepipe.transform(this.tempCurrentPolicy?.effectiveDate, 'yyyy-MM-dd'),this.datepipe.transform(this.tempCurrentPolicy?.expireDate, 'yyyy-MM-dd'),this.tempCurrentPolicy?.noOfAmendmentsMade,this.tempCurrentPolicy?.policyMod);
      await this.getPolicyQuotesList();
      this.tempPolicyList = this.PolicyQuotesList;
      await this.filterPolicy();
    }
    else if(this.submitType == "policyLimits"){
      var data = {
        "jobSiteUnitCommonId":this.policyDetails.jobSiteUnitCommandId,
        "jobSiteLimit":this.ProjectLimitValue,
        "unitCommonId":this.policyDetails.unitCommandId,
        "eqLimit":this.policyDetails?.policyDetails?.earthQuake?.limit != 0 ? this.EQValue : this.policyDetails?.policyDetails?.earthQuake?.limit,
        "floodLimit":this.policyDetails?.policyDetails?.flood?.limit != 0 ? this.floodValue : this.policyDetails?.policyDetails?.flood?.limit,
        "deductible":this.deductibleValue,
        "amendReasonCd":(this.amendReason != undefined && this.amendReason.length>0?this.amendReason.join():null),
        "policyId":this.policyDetails.policyId,
        "amendType":"updateCoverage",
        "rateOnly":false,
        "amendEffectiveDate":this.datepipe.transform(this.policyDetails?.policyStartDate,"yyyy-MM-dd")
      }
      element != undefined ? element.classList.add("calculateLbl") : null;
      var prevValue = {
        "jobSiteUnitCommonId":this.policyDetails.jobSiteUnitCommandId,
        "jobSiteLimit":this.tempProjectLimitValue,
        "unitCommonId":this.policyDetails.unitCommandId,
        "eqLimit":this.policyDetails?.policyDetails?.earthQuake?.limit != 0 ? this.tempEQNumber : this.policyDetails?.policyDetails?.earthQuake?.limit,
        "floodLimit":this.policyDetails?.policyDetails?.flood?.limit != 0 ? this.tempFloodNumber : this.policyDetails?.policyDetails?.flood?.limit,
        "deductible":this.tempDeductibleNumber,
        "amendReasonCd":(this.amendReason != undefined && this.amendReason.length>0?this.amendReason.join():null),
        "policyId":this.policyDetails.policyId,
        "amendType":"updateCoverage",
        "rateOnly":true,
        "amendEffectiveDate":this.datepipe.transform(this.policyDetails?.policyStartDate,"yyyy-MM-dd")
      }
      if(this.jp.query(this.coverageQuestionnaire,"$..[?(@.key == 'amendReasonText')]")?.length > 0){
        this.jp.query(this.coverageQuestionnaire,"$..[?(@.key == 'amendReasonText')]")[0].answer = await this.getAmendDesc("Coverage",this.coverageQuestionnaire);
      }
      let previousValue = {
        'ProjectLimit':this.policyDetails?.jobsiteLimit.replace('$', ''),
        'Deductible':this.policyDetails?.policyDetails?.deductibleValue,
        'Flood':this.policyDetails?.policyDetails?.flood?.limitValue,
        'EarthQuake':this.policyDetails?.policyDetails?.earthQuake?.limitValue
      }
      amendResponse = await this.serviceLayer.SubmitPolicyCoverage(this.coverageQuestionnaire,data,previousValue,this.policyDetails.referenceNumber,this.policyDetails?.policyNumber,this.isClaimFound,this.isPendingAmendment,prevValue,this.policyDetails?.clientInfo?.insuredName,this.tempCurrentPolicy?.productCode,this.datepipe.transform(this.tempCurrentPolicy?.effectiveDate, 'yyyy-MM-dd'),this.datepipe.transform(this.tempCurrentPolicy?.expireDate, 'yyyy-MM-dd'),this.tempCurrentPolicy?.noOfAmendmentsMade,this.tempCurrentPolicy?.policyMod);
      await this.getPolicyQuotesList();
      this.tempPolicyList = this.PolicyQuotesList;
      await this.filterPolicy();
    }
    element != undefined ? element.classList.remove("calculateLbl") : null;
    
    this.isBPMiAmend = amendResponse?.isBPMiAmendment == true;
    this.showPolicyConfirm = true;
    this.isClosed = false;
  }

  async onChangeProject() {
    this.isAcceptJobsiteLimit = false;
    if(!this.validateMinProject && !this.validateMaxProject) {
      if(this.ProjectLimitValue  != this.originalProjectLimit) {
        if(this.ProjectLimitValue >= this.originalProjectLimit){
          this.validateMinProject = false;
          this.validateMaxProject = false;
          this.isAcceptJobsiteLimit = true;
          let policypayload:any={};
          policypayload.ProjectLimitValue = this.ProjectLimitValue;
          policypayload.deductibleValue = this.deductibleValue;
          policypayload.floodValue = this.floodValue;
          policypayload.EQValue = this.EQValue;
          this.dropdownResult = await this.serviceLayer.getPolicyLimits(policypayload);
          this.originalProjectLimit = this.ProjectLimitValue;
          if(this.dropdownResult != undefined) {
            this.DeductibleList = this.onChangeDeductibleValue();
            // this.deductibleValue = this.jp.query(this.DeductibleList,"$..[?(@.isDefault == true)]")[0].limitValue;
            if(this.policyDetails?.policyDetails?.flood?.limit != 0){
              this.FloodList = this.dropdownResult['floodLimitOptions'];
              // this.floodValue = (this.jp.query(this.FloodList,"$..[?(@.isDefault == true)]") && this.jp.query(this.FloodList,"$..[?(@.isDefault == true)]")?.length > 0) ? this.jp.query(this.FloodList,"$..[?(@.isDefault == true)]")[0].limitValue : ''; 
            }
            if(this.policyDetails?.policyDetails?.earthQuake?.limit != 0){
              this.EQList = this.dropdownResult['earthquakeLimitOptions'];
              // this.EQValue = (this.jp.query(this.EQList,"$..[?(@.isDefault == true)]") && this.jp.query(this.EQList,"$..[?(@.isDefault == true)]")?.length > 0) ? this.jp.query(this.EQList,"$..[?(@.isDefault == true)]")[0].limitValue : '';
            }                  
            this.disabledFloodEQoptions();
          }
          // this.showFloodEdit = false;
          // this.showEQEdit = false;
          this.amendReason.push("LMT_EXPOS");
        }
      }
    }
  }

  UndoProjectLimit() {
    this.showProjectEdit = true;
    this.ProjectLimitValue = this.tempProjectLimitValue;
    this.originalProjectLimit = this.ProjectLimitValue
    this.DeductibleList = this.templimits["DeductibleList"];
    this.deductibleValue = this.tempDeductibleNumber;
    this.floodValue = this.policyDetails?.policyDetails?.flood?.limitValue;
    this.EQValue = this.policyDetails?.policyDetails?.earthQuake?.limitValue;
    this.FloodList = this.templimits["FloodList"];
    this.EQList = this.templimits["EQList"];
    this.validateMaxProject = false;
    this.validateMinProject = false;
    this.showFloodEdit = true;
    this.showEQEdit = true;
    this.showdeductibleEdit = true;
    this.amendReason = [];
    this.isAcceptJobsiteLimit = false;
    this.disabledFloodEQoptions();
  }

  UndoDeductibleLimit() {
    this.showdeductibleEdit = true;
    // this.deductibleValue = this.jp.query(this.DeductibleList,"$..[?(@.isDefault == true)]")[0].limitValue;
    this.deductibleValue = this.policyDetails?.policyDetails?.deductibleValue;
    _.remove(this.amendReason, function (n) {
      return n== 'Deductible';
    })
  }

  UndoFloodLimit() {
    this.showFloodEdit = true;
    // this.floodValue = this.jp.query(this.FloodList,"$..[?(@.isDefault == true)]")[0].limitValue;
    this.floodValue = this.policyDetails?.policyDetails?.flood?.limitValue;
    _.remove(this.amendReason, function (n) {
      return n== 'Flood';
    })
  }

  UndoEQLimit() {
    this.showEQEdit = true;
    this.EQValue = this.policyDetails?.policyDetails?.earthQuake?.limitValue;
    _.remove(this.amendReason, function (n) {
      return n== 'EQ';
    })
  }

  async getPolicyQuotesList() {
    var policyQuotesList = await this.serviceLayer.getSearchPoliciesList('Policy');
    if(policyQuotesList != undefined && policyQuotesList != null && policyQuotesList.length>0) {
      var policyList = policyQuotesList.filter(s => s.typeName == 'Policy');
    }
    var WantToList = [
      { "label": "Report a claim", "value": "Report a claim", "disabled": false },
      { "label": "Manage a policy", "value": "Manage my policy", "disabled": false },
      { "label": "Request Evidence of insurance", "value": "Request Evidence of insurance", "disabled": false },
      { "label": "Cancel a policy", "value": "Cancel my policy", "disabled": false }
    ];
    if (policyList != undefined && policyList.length > 0) {
      policyList.forEach(policy => {
        policy['wantedTo'] = _.cloneDeep(WantToList);
        if (this.statusChecks.includes(policy.status.toUpperCase())) {
          policy['wantedTo'][2].disabled = true;
          policy['wantedTo'][3].disabled = true;
        }
      });
    }
    this.PolicyQuotesList = policyQuotesList;    
    // window.localStorage.setItem("policyQuotesList", JSON.stringify(policyQuotesList));
  }

  validateLimits() {
      return ((this.deductibleValue == this.tempDeductibleNumber) 
      &&(this.floodValue == this.tempFloodNumber) 
      &&(this.EQValue == this.tempEQNumber)
      &&(!this.isAcceptJobsiteLimit) || this.ProjectLimitValue < this.originalProjectLimit);
  }

  onChangeDropdown(value) {
    var result = this.amendReason.filter(x=>x == value).length;
    if(result==0) {
      this.amendReason.push(value);
    }
  }
  onChangeDeductibleValue(){
    const originalOptions = this.policyDetails?.policyDetails?.deductibleOptions;

    this.DeductibleList = originalOptions.map(opt => ({
      ...opt,
      isDisabled: opt.limitValue === "2,500", // Disable the limitValue equals "2,500" in dropdownlist under BFMIT-11
    }));

    return this.DeductibleList;
  }

  async EditBlanketAI() {
    this.isConfirmBPMiChange = false;
    this.isConfirmBPMi = false;
    this.BlanketInfo.showBlanket = true;
    this.BlanketInfo.blanketList = [];
    this.BlanketInfo.blanketList = this.policyDetails?.blanketAIOptions;
    this.BlanketInfo.blanketAI = this.policyDetails?.clientInfo?.isBlanketInsured?.code;
    this.BlanketInfo["unitCommonId"] = this.policyDetails?.clientInfo?.blanketAIUnitCommandId;
    this.BlanketInfo.tempBlanketValue = this.BlanketInfo.blanketAI;
    this.BlanketInfo.showBlanketAIEdit = true;
    var element = document.getElementById("GettingID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    this.updateBlanketQuestionnaire = await this.serviceLayer.getPolicyQuestionnaire("updateBlanketAI");
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
  }

  UndoBlanketAI() {
    this.BlanketInfo.blanketAI = this.BlanketInfo.tempBlanketValue;
    this.BlanketInfo.showBlanketAIEdit = true;
  }

  closeBlanketAI() {
    this.BlanketInfo.showBlanket = false
  }

  async UpdateBlanketAI() {
    var questionnaire = _.cloneDeep(this.updateBlanketQuestionnaire);
    var amendQuestionnaire = this.jp.query(questionnaire.questionnaire,"$..[?(@.key =='AmendQuestionnare')]")[0].questionAnswer;
    var AmendLabels = {
      "policyId":this.policyDetails?.policyId,
      "amendEffectiveDate":this.datepipe.transform(new Date(), 'yyyy-MM-dd'),
      "amendType":"updateBlanketAI",
      "amendReasonCd":"AI"
    }
    amendQuestionnaire?.forEach(element => {
      if(AmendLabels[element.key] != undefined) {
        element.answer = AmendLabels[element.key];
      }
    });
    var blanketQuestionnaire = this.jp.query(questionnaire.questionnaire,"$..[?(@.key =='BlanketAIInfo')]")[0].questionAnswer;
    blanketQuestionnaire.forEach(element => {
      if(this.BlanketInfo[element.key] != undefined) {
        element.answer = this.BlanketInfo[element.key];
        if(element.key == 'blanketAI'){
          element.propertyName = 'BlanketInsured';
          element.isChanged = element.answer != this.BlanketInfo.tempBlanketValue;
        }
      }
    });
    var element = document.getElementById("UpdateID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    if(this.jp.query(questionnaire,"$..[?(@.key == 'amendReasonText')]")?.length > 0){
      // this.jp.query(questionnaire,"$..[?(@.key == 'amendReasonText')]")[0].answer = await this.getAmendDesc("blanketAI",questionnaire);
    }
    let amendResponse:any = await this.serviceLayer.SubmitNameInsured(questionnaire,'',this.policyDetails.referenceNumber,this.policyDetails?.policyNumber,this.isClaimFound,this.isPendingAmendment,this.policyDetails?.clientInfo?.insuredName,this.tempCurrentPolicy?.productCode,this.datepipe.transform(this.tempCurrentPolicy?.effectiveDate, 'yyyy-MM-dd'),this.datepipe.transform(this.tempCurrentPolicy?.expireDate, 'yyyy-MM-dd'),this.tempCurrentPolicy?.noOfAmendmentsMade,this.tempCurrentPolicy?.policyMod);
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
    this.isBPMiAmend = amendResponse?.isBPMiAmendment == true;
    this.showPolicyConfirm = true;
    this.isClosed = false;
  }
   
  AIEdit() {
    this.BlanketInfo.showBlanketAIEdit=false;
    setTimeout(function() { $('#BlanketID').focus() }, 100);
  }
  
  focus(id) {
    setTimeout(function() { $('#'+id).focus() }, 100);
  }

  UndoExpirationDate() {
    this.expirationDate = this.tempExpirationDate;
    this.showExpiration = true;
  }

  public isClosed:boolean =false;
  async closeConfirmation() {
    if(!this.isClosed) {      
      this.isClosed = true;      
      var element = document.getElementById("GettingID");
      if(element != undefined && element != null) {
        element.classList.add("calculateLbl");
      }
      await this.getPolicyQuotesList(); 
      this.tempPolicyList = this.PolicyQuotesList;
      this.filterPolicy();
      if(element != undefined && element != null) {
        element.classList.remove("calculateLbl");
      }
      if(!this.IsCancelPolicy){
        if(this.PolicyQuotesList && this.PolicyQuotesList.length > 0 && this.PolicyQuotesList.filter(c=>c.policyNumber == (this.cancelledPolicy != undefined && this.cancelledPolicy != '' ? this.cancelledPolicy : this.policyDetails?.policyNumber)).length > 0){
          let policy = this.PolicyQuotesList.filter(c=>c.policyNumber == (this.cancelledPolicy != undefined && this.cancelledPolicy != '' ? this.cancelledPolicy : this.policyDetails?.policyNumber))[0];
          let id = this.PolicyQuotesList.findIndex(c=>c.policyNumber == (this.cancelledPolicy != undefined && this.cancelledPolicy != '' ? this.cancelledPolicy : this.policyDetails?.policyNumber));
          this.policyChangeRequest(policy,id)
        }   
        else{
          var element = document.getElementById("GettingID");
          if(element != undefined && element != null) {
            element.classList.add("calculateLbl");
          }
          this.policyDetails = await this.serviceLayer.getPolicyDetails(this.cancelledPolicy != undefined && this.cancelledPolicy != '' ? this.cancelledPolicy : this.policyDetails?.policyNumber,this.tempCurrentPolicy?.policyMod);               
          await this.getBPMIFields(this.cancelledPolicy != undefined && this.cancelledPolicy != '' ? this.cancelledPolicy : this.policyDetails?.policyNumber);      
          await this.getClaimAndPendingAmendFound();      
          if(element != undefined && element != null) {
            element.classList.remove("calculateLbl");
          }
        } 
      }               
      this.cancelledPolicy = '';      
      this.showPolicyConfirm = false;
      this.isBPMiAmend = false;
      this.EditPolicy = false;
      this.ShowEditMailView = false;
      this.EditMailing = false;
      this.MailingType = "NewMailingAddress";
      this.MailingForm = {};
      this.showPremium = false; 
      this.BlanketInfo.showBlanket=false;
      this.EditFinancial = false;
      if(this.submitType == "ExtendTerm") {
        this.editEffective = false;
      }
      else if(this.submitType == "policyLimits"){
        this.onEditPolicy = false;
      }
      //this.PolicyorName = null;
    }

  }

  async openFinancialInterest(){
    this.ViewFinancial = true;
    this.interestTypeList = this.jp.query(this.policyDetails,"$..financialInterest.interestTypesOptions")[0];
    var element = document.getElementById("GettingID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    let policyData = await this.serviceLayer.getPolicyQuestionnaire("updateMailingAddress");
    this.FinancialInterestTypeQuestionaire = await this.serviceLayer.getPolicyQuestionnaire("updateAddInterest");    
    this.stateList = this.jp.query(policyData,"$..[?(@.key == 'AddressInfo')].questionAnswer[?(@.key == 'state')].questionOptions")[0];
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
  }
  async editFinancialInterest(address){
    this.isConfirmBPMiChange = false;
    this.isConfirmBPMi = false;
    this.EditFinancial = true;
    this.isCreateFinancialInterest= false;
    this.financialEditModel = _.cloneDeep(address)
    this.financialEditModel.interestTypeCode = this.interestTypeList.filter(c=>c.text == this.financialEditModel.interestType)[0].code;
    this.financialEditModel.addressInfo[0].addressLine1 = (this.financialEditModel.addressInfo[0].addressNo ? (this.financialEditModel.addressInfo[0].addressNo + ' ') : '') + this.financialEditModel.addressInfo[0].addressLine1;
    this.financialEditModel.addressInfo[0].addressNo = '';
    this.tempfinancialEditModel = _.cloneDeep(this.financialEditModel);
    this.showInterestType = true;
    this.showBusinessName = true;
    this.showInterestAddress = true;
  }
  async addFinancialInterest(){
    this.EditFinancial = true;
    this.isCreateFinancialInterest = true;
    this.financialEditModel.interestTypeCode = "";
    this.financialEditModel.businessName = "";
    this.financialEditModel.interestID = 0;
    let addressInfo:any = {};
    addressInfo.addressNo = '';
    addressInfo.addressLine1 = '';
    addressInfo.city = '';
    addressInfo.state = '';
    addressInfo.zip = null;
    this.financialEditModel.addressInfo = [];
    this.financialEditModel.addressInfo.push(addressInfo);
    this.tempfinancialEditModel = _.cloneDeep(this.financialEditModel);
    this.showInterestType = false;
    this.showBusinessName = false;
    this.showInterestAddress = false;
    this.financialIntform ? this.financialIntform.resetForm() : null;
    this.isConfirmBPMi = false;
    this.isConfirmBPMiChange = false;
  }
  async closeEditFinancial(){
    this.EditFinancial = false;
  }
  async UndoInteretType(type){    
    if(type == 'interestTypeCode'){
      this.financialEditModel[type] = _.cloneDeep(this.tempfinancialEditModel[type]);
      this.showInterestType = true;
    }    
    else if(type == 'businessName'){
      this.financialEditModel[type] = _.cloneDeep(this.tempfinancialEditModel[type]);
      this.showBusinessName = true;
    }  
    else if(type == 'addressInfo'){
      this.financialEditModel[type] = _.cloneDeep(this.tempfinancialEditModel[type]);
      this.showInterestAddress = true;
    }
  }
  diableFinancialSubmit(){
    if(_.isEqual(this.financialEditModel,this.tempfinancialEditModel)){
      return true;
    }
    return false
  }
  diableBillingSubmit(){
    if(_.isEqual(this.BillingAddressInfo,this.tempBillingAddressInfo)){
      return true;
    }
    return false
  }
  async submitFinancialInterest(form){
    if(this.financialEditModel.interestTypeCode == null || this.financialEditModel.interestTypeCode == '' || this.financialEditModel.businessName == null || this.financialEditModel.businessName == '' ||
    this.financialEditModel.addressInfo[0].addressLine1 == null || this.financialEditModel.addressInfo[0].addressLine1 == '' ||
    this.financialEditModel.addressInfo[0].city == null || this.financialEditModel.addressInfo[0].city == '' || this.financialEditModel.addressInfo[0].state == null || this.financialEditModel.addressInfo[0].state == '' || 
    this.financialEditModel.addressInfo[0].zip == null || this.financialEditModel.addressInfo[0].zip == ''){

    }
    else{
      var element = document.getElementById("UpdateID");
      if(element != undefined && element != null) {
        element.classList.add("calculateLbl");
      }
      let Payload = await this.changeFinancialInterestJson(this.financialEditModel,(this.financialEditModel.interestID && this.financialEditModel.interestID != 0) ? 'update' : 'add')
      let keys = this.jp.query(Payload,"$..[?(@.key == 'AddInterestInfo')].questionAnswer")[0]
      if(keys && keys.length > 0){
        keys.map(c=>{
          c.id = this.financialEditModel.interestID ? this.financialEditModel.interestID : 0
          c.propertyName = "InsurableInterest";
        });
      }
      let previousValue = null;
      if(this.tempfinancialEditModel.interestType != undefined){
        previousValue = {
          'PropertyValue':this.tempfinancialEditModel.interestType+' '+this.tempfinancialEditModel.businessName+','+this.tempfinancialEditModel.addressInfo[0].addressLine1+','+this.tempfinancialEditModel.addressInfo[0].city+','+this.tempfinancialEditModel.addressInfo[0].state+','+this.tempfinancialEditModel.addressInfo[0].zip
        }
      }
      let amendResponse:any = await this.serviceLayer.savePremium(Payload,previousValue,false,this.policyDetails.referenceNumber,this.policyDetails?.policyNumber,this.isClaimFound,this.isPendingAmendment,this.policyDetails?.clientInfo?.insuredName,this.tempCurrentPolicy?.productCode,this.datepipe.transform(this.tempCurrentPolicy?.effectiveDate, 'yyyy-MM-dd'),this.datepipe.transform(this.tempCurrentPolicy?.expireDate, 'yyyy-MM-dd'),this.tempCurrentPolicy?.noOfAmendmentsMade,this.tempCurrentPolicy?.policyMod);
      if(element != undefined && element != null) {
        element.classList.remove("calculateLbl");
      }
      form.submitted = false;
      this.isClosed = false;
      // this.EditFinancial = false;
      this.isBPMiAmend = amendResponse?.isBPMiAmendment == true;
      this.showPolicyConfirm = true;
    }
  }
  deleteFinancialInterest(interest){
    this.confirmationService.confirm({
      message: 'Do you want to delete?',
      header: 'Financial Interest',
      accept: async () => {
        var element = document.getElementById("UpdateID");
        if(element != undefined && element != null) {
          element.classList.add("calculateLbl");
        }
        let deletePayload = await this.changeFinancialInterestJson(interest,'delete')
        let keys = this.jp.query(deletePayload,"$..[?(@.key == 'AddInterestInfo')].questionAnswer")[0];
        if(keys && keys.length > 0){
          keys.map(c=>{
            c.isDeleted = true;
            c.propertyName = "InsurableInterest";
            c.id = interest.interestID;
          });
        }
        let amendResponse:any = await this.serviceLayer.savePremium(deletePayload,'',false,this.policyDetails.referenceNumber,this.policyDetails?.policyNumber,this.isClaimFound,this.isPendingAmendment,this.policyDetails?.clientInfo?.insuredName,this.tempCurrentPolicy?.productCode,this.datepipe.transform(this.tempCurrentPolicy?.effectiveDate, 'yyyy-MM-dd'),this.datepipe.transform(this.tempCurrentPolicy?.expireDate, 'yyyy-MM-dd'),this.tempCurrentPolicy?.noOfAmendmentsMade,this.tempCurrentPolicy?.policyMod);
        this.isClosed = false;
        if(element != undefined && element != null) {
          element.classList.remove("calculateLbl");
        }
        this.isBPMiAmend = amendResponse?.isBPMiAmendment == true;
        this.showPolicyConfirm = true;
        },
      reject: (type) => {

      }
    });
  }
  async changeFinancialInterestJson(data,type){
    let newData = _.cloneDeep(this.FinancialInterestTypeQuestionaire);
    this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'streetNo')]")[0].answer = _.cloneDeep('');    
    this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'address1')]")[0].answer = _.cloneDeep(data.addressInfo[0].addressLine1);    
    this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'city')]")[0].answer = _.cloneDeep(data.addressInfo[0].city);    
    this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'state')]")[0].answer = _.cloneDeep(data.addressInfo[0].state);    
    this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'county')]")[0].answer = _.cloneDeep(data.addressInfo[0].county ? data.addressInfo[0].county : 'ABC');
    this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'postalCode')]")[0].answer = _.cloneDeep(data.addressInfo[0].zip);    
    this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'unitCommonId')]")[0].answer = _.cloneDeep(this.policyDetails?.jobSiteUnitCommandId);
    this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'interestType')]")[0].answer = _.cloneDeep(data.interestTypeCode ? data.interestTypeCode : this.interestTypeList.filter(c=>c.text == data.interestType)[0].code);
    this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'interestType')]")[0].questionHelpText = _.cloneDeep(data.interestType ? data.interestType : this.interestTypeList.filter(c=>c.code == data.interestTypeCode)[0].text);
    // this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'addInterestId')]")[0].answer = type == 'add' ? 0 : _.cloneDeep(data.interestID);
    this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'businessName')]")[0].answer = _.cloneDeep(data.businessName);    
    if(type == 'update'){
      // this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'streetNo')]")[0].isChanged = data.addressInfo[0].addressNo != this.tempfinancialEditModel?.addressInfo[0].addressNo;
      this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'address1')]")[0].isChanged = data.addressInfo[0].addressLine1 != this.tempfinancialEditModel?.addressInfo[0].addressLine1;
      this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'city')]")[0].isChanged = data.addressInfo[0].city != this.tempfinancialEditModel?.addressInfo[0].city;
      this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'state')]")[0].isChanged = data.addressInfo[0].state != this.tempfinancialEditModel?.addressInfo[0].state;
      this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'postalCode')]")[0].isChanged = data.addressInfo[0].zip != this.tempfinancialEditModel?.addressInfo[0].zip;
      this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'businessName')]")[0].isChanged = data.businessName != this.tempfinancialEditModel.businessName;
    }
    else{
      this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'address1')]")[0].isChanged = true;
      this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'city')]")[0].isChanged = true;
      this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'state')]")[0].isChanged = true;
      this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'postalCode')]")[0].isChanged = true;
      this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'businessName')]")[0].isChanged = true;
      this.jp.query(newData,"$..[?(@.key == 'AddInterestInfo')].questionAnswer[?(@.key == 'interestType')]")[0].isChanged = true;
    }

    this.jp.query(newData,"$..[?(@.key == 'AmendQuestionnare')].questionAnswer[?(@.key == 'policyId')]")[0].answer = _.cloneDeep(this.policyDetails?.policyId);
    this.jp.query(newData,"$..[?(@.key == 'AmendQuestionnare')].questionAnswer[?(@.key == 'amendEffectiveDate')]")[0].answer = _.cloneDeep(this.datepipe.transform(new Date(), 'yyyy-MM-dd'));
    this.jp.query(newData,"$..[?(@.key == 'AmendQuestionnare')].questionAnswer[?(@.key == 'amendType')]")[0].answer = "updateAddInterest";
    this.jp.query(newData,"$..[?(@.key == 'AmendQuestionnare')].questionAnswer[?(@.key == 'amendReasonCd')]")[0].answer = "AI";
    if(this.jp.query(newData,"$..[?(@.key == 'AmendQuestionnare')].questionAnswer[?(@.key == 'amendReasonText')]")?.length > 0){
      this.jp.query(newData,"$..[?(@.key == 'AmendQuestionnare')].questionAnswer[?(@.key == 'amendReasonText')]")[0].answer = await this.getAmendDesc("financialInterest",newData);
    }
    return newData;
  }
  async getClaimAndPendingAmendFound(){
    this.isPendingAmendment = false; 
    this.isClaimFound = false;
    if(this.policyDetails && this.policyDetails.claimDetails && this.policyDetails.claimDetails.length > 0 && this.policyDetails.claimDetails.filter(c=>c.status == 'Open').length > 0){
      this.isClaimFound = true;
    }
    if(this.policyDetails && this.policyDetails.numberOfPendingAmendments != undefined && this.policyDetails.numberOfPendingAmendments != '' && Number(this.policyDetails.numberOfPendingAmendments) > 0){
      this.isPendingAmendment = true; 
    }
  }
  closeBillingAddress() {
    this.EditBilling = false;
    this.billingSubmit = false;
  }
  async editBillingAddress() {
    this.EditBilling = true;
    var element = document.getElementById("GettingID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    this.BillingQuestionnaire = await this.serviceLayer.getPolicyQuestionnaire("updateMailingAddress");
    this.BillingQuestionnaire.questionnaire.map(c=>{
      if(c.key == 'AddressInfo'){
        c.key = "BillingAddress"
      }
    })
    let countyValue = this.policyDetails?.clientInfo?.billingAddress[0]?.county;
    if(countyValue == undefined || countyValue == null || countyValue.length<3) {
      countyValue = "ABC";
    }
    this.BillingAddressInfo = {
      "addressId":this.policyDetails?.clientInfo?.billingAddress[0]?.addressID,
      "streetNo":'',
      "address1":(this.policyDetails?.clientInfo?.billingAddress[0]?.addressNo ? (this.policyDetails?.clientInfo?.billingAddress[0]?.addressNo + ' ') : '') + this.policyDetails?.clientInfo?.billingAddress[0]?.addressLine1,
      "city":this.policyDetails?.clientInfo?.billingAddress[0]?.city,
      "state":this.policyDetails?.clientInfo?.billingAddress[0]?.state,
      "county":countyValue,
      "postalCode":this.policyDetails?.clientInfo?.billingAddress[0]?.zip
    }
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
    this.tempBillingAddressInfo = _.cloneDeep(this.BillingAddressInfo);
    var mailQuestionnaire = this.jp.query(this.BillingQuestionnaire.questionnaire,"$..[?(@.key == 'BillingAddress')]")[0].questionAnswer;
    this.stateList = this.jp.query(mailQuestionnaire,"$..[?(@.key == 'state')]")[0].questionOptions;
  }
  async UpdateBillingAddress() {
    this.billingSubmit = true;  
    var Questionnaire = _.cloneDeep(this.BillingQuestionnaire);
    var amendQuestionnaire = this.jp.query(Questionnaire.questionnaire,"$..[?(@.key == 'AmendQuestionnare')]")[0].questionAnswer;
    var AmendLabels = {
      "policyId":this.policyDetails?.policyId,
      "amendEffectiveDate":this.datepipe.transform(new Date(), 'yyyy-MM-dd'),
      "amendType":"updateBillingAddress"
    }
    amendQuestionnaire.forEach(element => {
      if(AmendLabels[element.key] != undefined) {
        element.answer = AmendLabels[element.key];
      }
    });
    var addressQuestionnaire = this.jp.query(Questionnaire.questionnaire,"$..[?(@.key == 'BillingAddress')]")[0].questionAnswer;
    addressQuestionnaire.forEach(element => {
      // if(this.BillingAddressInfo[element.key] != undefined) {
        element.answer = this.BillingAddressInfo[element.key] ? this.BillingAddressInfo[element.key] : '';
        element.propertyName = 'BillingAddress';
        element.isChanged = this.BillingAddressInfo[element.key] != this.tempBillingAddressInfo[element.key];
      // }
    });
    var element = document.getElementById("UpdateID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    if(this.jp.query(Questionnaire,"$..[?(@.key == 'amendReasonText')]")?.length > 0){
      this.jp.query(Questionnaire,"$..[?(@.key == 'amendReasonText')]")[0].answer = await this.getAmendDesc("billingAddress",Questionnaire);
    }
    let previousValue={
      'PropertyID':this.tempBillingAddressInfo.addressId,
      'PropertyValue':this.tempBillingAddressInfo.address1+','+this.tempBillingAddressInfo.city+','+this.tempBillingAddressInfo.state+','+this.tempBillingAddressInfo.postalCode
    }
    await this.serviceLayer.SubmitMailingAddress(Questionnaire,previousValue,this.policyDetails.referenceNumber,this.policyDetails?.policyNumber,this.isClaimFound,this.isPendingAmendment,this.policyDetails?.clientInfo?.insuredName,this.tempCurrentPolicy?.productCode,this.datepipe.transform(this.tempCurrentPolicy?.effectiveDate, 'yyyy-MM-dd'),this.datepipe.transform(this.tempCurrentPolicy?.expireDate, 'yyyy-MM-dd'),this.tempCurrentPolicy?.noOfAmendmentsMade,this.tempCurrentPolicy?.policyMod);
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
    element = document.getElementById("GettingID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    await this.getPolicyQuotesList();
    await this.getBPMIFields(this.policyDetails?.policyNumber);
    this.policyDetails = await this.serviceLayer.getPolicyDetails(this.policyDetails?.policyNumber,this.tempCurrentPolicy?.policyMod);
    await this.getClaimAndPendingAmendFound();
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
    this.tempPolicyList = this.PolicyQuotesList;
    await this.filterPolicy();
    this.closeBillingAddress();
    this.showBPMIConfirmation = true;
  }
  async EditPayPlan() {
    this.PayPlanInfo.showPayPlan = true;
    this.PayPlanInfo.PayPlanList = [];
    this.PayPlanInfo.PayPlanList = this.policyDetails?.paymentPlanOptions;
    this.PayPlanInfo.PayPlan = this.policyDetails?.clientInfo?.paymentPlan;
    if(this.PayPlanInfo.PayPlanList && this.PayPlanInfo.PayPlanList.length > 0){
      this.PayPlanInfo.PayPlanCode = this.PayPlanInfo?.PayPlanList.filter(c=>(c.text).toUpperCase() == (this.PayPlanInfo?.PayPlan).toUpperCase())[0]?.code
    }
    this.PayPlanInfo["unitCommonId"] = this.policyDetails?.clientInfo?.blanketAIUnitCommandId;
    this.PayPlanInfo.tempPayPlanCode = this.PayPlanInfo.PayPlanCode;
    this.PayPlanInfo.showPayPlanEdit = true;
    // this.updateBlanketQuestionnaire = await this.serviceLayer.getPolicyQuestionnaire("updateBlanketAI");
  }
  closePayPlan() {
    this.PayPlanInfo.showPayPlan = false
  }
  PayplanEdit() {
    this.PayPlanInfo.showPayPlanEdit=false;
    setTimeout(function() { $('#payPlanID').focus() }, 100);
  }
  UndoPayPlan() {
    this.PayPlanInfo.PayPlanCode = this.PayPlanInfo.tempPayPlanCode;
    this.PayPlanInfo.showPayPlanEdit = true;
  }
  async UpdatePayplan() {
    var element = document.getElementById("UpdateID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    let policyData = await this.serviceLayer.getPolicyQuestionnaire("updatePayPlan");    
    var AmendQuestionnaire = this.jp.query(policyData,"$..[?(@.key == 'AmendQuestionnare')]")[0];
    var AmendLabels = {
      "policyId":this.policyDetails?.policyId,
      "amendEffectiveDate":this.datepipe.transform(new Date(), 'yyyy-MM-dd'),
      "amendType":"updatePayPlan"
    }
    AmendQuestionnaire.questionAnswer.forEach(element => {
      if(AmendLabels[element.key] != undefined) {
        element.answer = AmendLabels[element.key];
      }
    });
    let tempPayPlanQuestionnaire = {
      "questionnaire":[{
        key:"PayPlanQuestionnaire",
        questionAnswer:[{
          answer : (this.PayPlanInfo.PayPlanList && this.PayPlanInfo.PayPlanList.length > 0 && this.PayPlanInfo.PayPlanList.filter(c=>c.code == this.PayPlanInfo.PayPlanCode).length > 0 ? this.PayPlanInfo.PayPlanList.filter(c=>c.code == this.PayPlanInfo.PayPlanCode)[0].text : ''),
          key:"payPlan",
          isChanged:this.PayPlanInfo.PayPlanCode != this.PayPlanInfo.tempPayPlanCode,
          propertyName:"BillingPayPlan",
          id:0,
          type:"select"
        }]
      },
      AmendQuestionnaire]
    }        
    if(this.jp.query(tempPayPlanQuestionnaire,"$..[?(@.key == 'amendReasonText')]")?.length > 0){
      this.jp.query(tempPayPlanQuestionnaire,"$..[?(@.key == 'amendReasonText')]")[0].answer = await this.getAmendDesc("payPlan",tempPayPlanQuestionnaire);
    }
    let previousValue = {
      'PropertyValue':(this.PayPlanInfo.PayPlanList && this.PayPlanInfo.PayPlanList.length > 0 && this.PayPlanInfo.PayPlanList.filter(c=>c.code == this.PayPlanInfo.PayPlanCode).length > 0 ? this.PayPlanInfo.PayPlanList.filter(c=>c.code == this.PayPlanInfo.tempPayPlanCode)[0].text : '')
    }
    await this.serviceLayer.savePremium(tempPayPlanQuestionnaire,previousValue,false,this.policyDetails.referenceNumber,this.policyDetails?.policyNumber,this.isClaimFound,this.isPendingAmendment,this.policyDetails?.clientInfo?.insuredName,this.tempCurrentPolicy?.productCode,this.datepipe.transform(this.tempCurrentPolicy?.effectiveDate, 'yyyy-MM-dd'),this.datepipe.transform(this.tempCurrentPolicy?.expireDate, 'yyyy-MM-dd'),this.tempCurrentPolicy?.noOfAmendmentsMade,this.tempCurrentPolicy?.policyMod);
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
    element = document.getElementById("GettingID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    await this.getPolicyQuotesList();
    await this.getBPMIFields(this.policyDetails?.policyNumber);
    this.policyDetails = await this.serviceLayer.getPolicyDetails(this.policyDetails?.policyNumber,this.tempCurrentPolicy?.policyMod);
    await this.getClaimAndPendingAmendFound();
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
    this.tempPolicyList = this.PolicyQuotesList;
    await this.filterPolicy();
    this.closePayPlan();
    this.showBPMIConfirmation = true;
  }
  async getBPMIFields(policynumber){
    this.BPMiFields = await this.serviceLayer.getBPMiFields(policynumber);
    this.isBPMiFields = {};
      if(this.BPMiFields && this.BPMiFields.length > 0){
        this.showExtendBPMi = this.BPMiFields.filter(x=>x.propertyName=="ExpirationDate").length>0?true:false;
        this.BPMiFields.map(c=>{          
          if(c.propertyName == "AdditionalNamedInsured" || c.propertyName == "InsurableInterest"){
            this.isBPMiFields[c.propertyName + c.propertyId] = {};
            this.isBPMiFields[c.propertyName + c.propertyId].isShow = true;
          }
          else if(this.IsBFMInternal && c.propertyName == "ExpirationDate"){
            this.isBPMiFields[c.propertyName] = {};
            this.isBPMiFields[c.propertyName].isShow = false
          }         
          else{
            this.isBPMiFields[c.propertyName] = {};
            this.isBPMiFields[c.propertyName].isShow = true
          }          
        })
      }
  }
  openEvidence(){
    this.isFromManagePolicy = true;
    this.isShowEvidence = true;
  }
  closeEvidence(){
    this.isShowEvidence = false;
    this.isFromManagePolicy = false;
  }
  async openReportClaim(policyDetails){
    this.policyDetails = await this.serviceLayer.getPolicyDetails(policyDetails.policyNumber,policyDetails.policyMod);
    this.policyDetails.status = policyDetails.status;
    if (['CANCELED', 'CANCELLED', 'PENDINGCANCELLATION'].includes(policyDetails.status.toUpperCase())) {
      this.policyDetails.modifyDate = this.policyChangeModal.modifyDate;
    }
    this.currentPolicy = policyDetails;
    this.isFromManagePolicy = true;
    this.isShowReportClaim = true;
    let userData:any={};
    userData.Email = this.dao?.loginUserDetail?.email;
    userData.AgencyCode = this.dao.agencyCode;
    userData.PolicyNumber = this.currentPolicy.policyNumber;
    userData.InsuredName = this.dao.insuredName;
    userData.ProgressToPage = "Report a Claim";
    let payloadDetail:any={};
    payloadDetail.endPointURL = await this.serviceLayer.getEndPoint("ManagePolicy", "PolicyDetails", [this.dao.loginUserDetail.userCompany,policyDetails.policyNumber,50]);
    payloadDetail.payload = "";
    payloadDetail.response = this.policyDetails;
    userData.Payload = JSON.stringify(payloadDetail);
    userData.TransactionStatus = "Success";
    userData.RateOnly = false;
    userData.ActionType = "Open Policy from Manage Policy"; 
    await this.serviceLayer.postUserActivity(userData);
  }
  closeReportClaim(){
    this.isShowReportClaim = false;
    this.isFromManagePolicy = false;
  }
  changeMonth(event){
    // $(".p-datepicker-next").removeClass('disIcon');
    // $(".p-datepicker-prev").removeClass('disIcon');
    if(event.year == this.maxyear && event.month == 11){
      $(".p-datepicker-next").hide()
    }
    if(event.year == this.year && event.month == 1){
      $(".p-datepicker-prev").addClass('disIcon');
    }
  }
  disabledFloodEQoptions(){
    this.FloodList?.forEach(flood=>{
      flood['disabled'] = false;
      if(Number(flood.limitValue) < Number(this.floodValue)){
        flood['disabled'] = true;
      }
    });
    this.EQList?.forEach(eq=>{
      eq['disabled'] = false;
      if(Number(eq.limitValue) < Number(this.EQValue)){
        eq['disabled'] = true;
      }
    })
  }
  ValidateExtensionPeriod(){
    const expDate = new Date(this.expirationDate);
    const exceedDays = this.HasExceedExtentioPeriod(expDate);
    this.IsPolicyPeriodExtensionReached = this.HasExceedExtentioPeriod(this.currentExpirationDate) > 730; 
    this.IsExceedExtentioPeriod = exceedDays > 730;
  }
  HasExceedExtentioPeriod(expirationDate: Date): number {
    const effDate = new Date(this.policyDetails?.policyStartDate);
    const expDate = new Date(expirationDate);
    const diffInMs = expDate.getTime() - effDate.getTime();
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    return diffInDays;
  }
  setActiveYear() {
    const popups = document.querySelectorAll('.p-datepicker');
    if (!popups.length) return;

    const popup = popups[popups.length - 1] as HTMLElement;
    if (!popup) return;

    const observer = new MutationObserver(() => {
      this.highlightTargetYear(popup);
    });

    observer.observe(popup, { childList: true, subtree: true });

    this.highlightTargetYear(popup);
  }

  highlightTargetYear(popup: HTMLElement) {
    const yearPicker = popup.querySelector('.p-yearpicker') as HTMLElement;
    if (!yearPicker) return;

    const startYear = this.currentExpirationDate.getFullYear();
    const targetYear = this.MaxExpirationDate.getFullYear();

    const years = yearPicker.querySelectorAll('.p-yearpicker-year');

    years.forEach((el: Element) => {
      const elHTMLElement = el as HTMLElement;
      const yearNum = parseInt(elHTMLElement.textContent || '', 10);

      if (yearNum === startYear || yearNum === targetYear) {
        this.renderer.removeClass(elHTMLElement, 'p-disabled');
        this.renderer.removeClass(elHTMLElement, 'p-highlight');
        elHTMLElement.focus();
      }
    });
  }

  async openAgentPortal(){
    this.serviceLayer.openLink('agentPortal',this.policyDetails?.clientInfo?.insuredName,this.policyDetails?.policyNumber);
  }
  public async getAmendDesc(Type,payload){
    let DescriptionText:string = '';
    if(payload != undefined && Type == 'NamedInsured'){
      let namedInsuredDesc = this.jp.query(payload,"$..[?(@.propertyName == '" + Type + "' && @.isChanged == true)]")
      if(namedInsuredDesc && namedInsuredDesc?.length > 0){
        DescriptionText = 'Named Insured is amended to read as follows: ' + namedInsuredDesc[0].answer + '<BR>';
      }      
      let additionalNamedInsured = this.jp.query(payload,"$..[?(@.propertyName == 'AdditionalNamedInsured' && @.isChanged == true)].answer");
      if(additionalNamedInsured?.length > 0){
        DescriptionText = DescriptionText + 'The following Additional insured(s) are (is) amended to the policy'
        let additionalNameDesc = '';
        additionalNamedInsured.map(c=>additionalNameDesc = additionalNameDesc + ' <BR> • ' + c);
        DescriptionText = DescriptionText + additionalNameDesc;
      }
    }
    if(payload != undefined && Type == 'Address'){
      let addressDesc = this.jp.query(payload,"$..[?(@.key == 'address1')]")[0].answer +',<BR> '+
                        this.jp.query(payload,"$..[?(@.key == 'city')]")[0].answer +', '+
                        this.jp.query(payload,"$..[?(@.key == 'state')]")[0].answer +', '+
                        this.jp.query(payload,"$..[?(@.key == 'postalCode')]")[0].answer;
      DescriptionText = 'Mailing Address is amended to read as follows:<BR>' + addressDesc;
    }
    if(payload != undefined && Type == 'ProjectAddress'){
      let addressDesc = this.jp.query(payload,"$..[?(@.key == 'address1')]")[0].answer +',<BR> '+
                        this.ProjectAddressInfo?.city + ', '+
                        this.ProjectAddressInfo?.state + ', '+
                        this.ProjectAddressInfo?.zip;
      DescriptionText = 'The Location address is amended to read as follows: <BR> ' + addressDesc;
    }
    if(payload != undefined && Type == 'Coverage'){
      let coverageDesc :string = '';      
      if(this.tempProjectLimitValue != this.ProjectLimitValue || this.changeNumber(this.tempFloodNumber) != this.changeNumber(this.floodValue) || this.changeNumber(this.tempEQNumber) != this.changeNumber(this.EQValue)){
        DescriptionText = 'The Builder Risk Coverage is amended as follows:<BR>';
      }
      if(this.tempProjectLimitValue != this.ProjectLimitValue){        
        coverageDesc = coverageDesc + 'Builders Risk Jobsite Limit is ' + (this.tempProjectLimitValue < this.ProjectLimitValue ? 'increased' : 'decreased') + 
                      ': From: $' + (this.tempProjectLimitValue)?.toString()?.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + ' To: $' + (this.ProjectLimitValue)?.toString()?.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + '<BR>';
      }      
      if(this.changeNumber(this.tempFloodNumber) != this.changeNumber(this.floodValue)){
        coverageDesc = coverageDesc + 'Flood coverage Limit is ' + (this.changeNumber(this.tempFloodNumber) < this.changeNumber(this.floodValue) ? 'increased' : 'decreased') + 
                      ': From: $' + this.tempFloodNumber + ' To: $' + this.floodValue + '<BR>';
      }
      if(this.changeNumber(this.tempEQNumber) != this.changeNumber(this.EQValue)){
        coverageDesc = coverageDesc + 'Earthquake coverage Limit is ' + (this.changeNumber(this.tempEQNumber) < this.changeNumber(this.EQValue) ? 'increased' : 'decreased') + 
                      ': From: $' + this.tempEQNumber + ' To: $' + this.EQValue + '<BR>';
      }
      DescriptionText = DescriptionText + coverageDesc;
      if(this.changeNumber(this.tempDeductibleNumber) != this.changeNumber(this.deductibleValue)){
        DescriptionText = DescriptionText + "Schedule Of Coverages - Builders' Risk - Comprehensive Form IM 7055 01/12 is amended as follows: The Deductible is amended to read:" + this.deductibleValue + '<BR>';
      }
                                
    }
    if(payload != undefined && Type == 'extendTerm'){
      DescriptionText = 'Policy coverage is extended to expire ' +this.datepipe.transform(new Date(this.datepipe.transform((this.expirationDate), 'MM-dd-yyyy')), 'MM-dd-yyyy')+ '<BR>' +
                        'ALL OTHER POLICY TERMS AND CONDITIONS REMAIN THE SAME<BR>';                    
    }
    if(payload != undefined && Type == 'blanketAI'){
      DescriptionText = "The Builder's Risk Coverage is amended as follow: Form IN 86 55 XX XX Blanket AI is added to the policy";
    }    
    if(payload != undefined && (Type == 'payPlan' || Type == 'billingAddress')){
      DescriptionText = "BFM does not handle in Genesys but in Berkley Billing";
    }
    if(payload != undefined && Type == 'financialInterest'){
      let interestName = this.interestTypeList.filter(c=>c.code == this.jp.query(payload,"$..[?(@.key == 'interestType')]")[0].answer)[0].text;
      DescriptionText = "The policy is amended to include following " + interestName + ' as follows:<BR>';
      DescriptionText = DescriptionText + ' <BR> • ' + this.jp.query(payload,"$..[?(@.key == 'businessName')]")[0].answer + '<BR>';
      DescriptionText = DescriptionText + this.jp.query(payload,"$..[?(@.key == 'address1')]")[0].answer +',<BR> '+
                        this.jp.query(payload,"$..[?(@.key == 'city')]")[0].answer +', '+
                        this.jp.query(payload,"$..[?(@.key == 'state')]")[0].answer +', '+
                        this.jp.query(payload,"$..[?(@.key == 'postalCode')]")[0].answer;
    }
    return DescriptionText;
  }
  public changeNumber(value){
    if(value == undefined || value == ''){
      return 0;
    }
    else{
      if(isNaN(Number(value?.toString()?.replaceAll(',','')))){
        return 0;
      }
      else{
        return Number(value?.toString()?.replaceAll(',',''));
      }
    }
  }
  public async postUserActivity(Payload,Status,RateOnly,ActionType,component,functionality,urlData){
    let userData :any = {};
    userData.Email = this.dao?.loginUserDetail?.email;
    userData.AgencyCode = this.dao.agencyCode;
    userData.PolicyNumber = this.dao.policyNumber;
    userData.InsuredName = this.dao.insuredName;
    userData.ProgressToPage = window.localStorage.getItem("policyType");
    let payloadDetail:any={};
    payloadDetail.endPointURL = await this.serviceLayer.getEndPoint(component, functionality, urlData);
    payloadDetail.payload = "";
    payloadDetail.response = Payload;
    userData.Payload = JSON.stringify(payloadDetail);
    userData.TransactionStatus = Status;
    userData.RateOnly = RateOnly;
    userData.ActionType = ActionType;
    this.serviceLayer.postUserActivity(userData);
  }

  async searchForPolicy() {
    
    if(this.PolicyorName != undefined && this.PolicyorName != null && this.PolicyorName.length >0){
      var policyQuotesList : any =[];
      policyQuotesList = await this.serviceLayer.getPoliciesBasedOnSearch(this.dao.loginUserDetail.email,this.PolicyorName);
      
      if(policyQuotesList != undefined && policyQuotesList != null && policyQuotesList.length>0) {
        var policyList = policyQuotesList.filter(s => s.typeName == 'Policy');
      }
      var WantToList = [
        { "label": "Report a claim", "value": "Report a claim", "disabled": false },
        { "label": "Manage a policy", "value": "Manage my policy", "disabled": false },
        { "label": "Request Evidence of insurance", "value": "Request Evidence of insurance", "disabled": false },
        { "label": "Cancel a policy", "value": "Cancel my policy", "disabled": false }
      ];
      if (policyList != undefined && policyList.length > 0) {
        policyList.forEach(policy => {
          policy['wantedTo'] = _.cloneDeep(WantToList);
          if (this.statusChecks.includes(policy.status.toUpperCase())) {
            policy['wantedTo'][2].disabled = true;
            policy['wantedTo'][3].disabled = true;
          }
        });
      }
      this.PolicyQuotesList = policyQuotesList; 
      this.tempPolicyList = policyQuotesList;
      window.localStorage.setItem("policyQuotesList", JSON.stringify(policyQuotesList));
      this.filterPolicy();
    }
  }

  public checkCancelledExpired() {
    let iconClass = 'policyEditIcon';
    if (this.statusChecks.includes(this.policyChangeModal?.status.toUpperCase())) {
      iconClass = 'policyDisableEditIcon';
    }
    if (this.tempCurrentPolicy?.isExceedsMaximumAllowedAmendment) {
      iconClass = 'policyDisableEditIcon';
    }
    if (this.isCancelExpired) {
      iconClass = 'policyDisableEditIcon';
    }
    return iconClass;
  }

  public checkEditDisabled(passedValue: boolean) {
    let iconClass = '';
    if (passedValue || this.isCancelExpired || this.IsPolicyEvent) {
      iconClass = 'editdisableIcls';
    }
    return iconClass
  }
}
